export default {
  hrbee_packages: {
    assets: 'Assets module',
    employee: 'Employee module',
    feeds: 'Feeds module',
    recruitment: 'Recruitment module',
    vacations: 'Vacations module',
    wages: 'Wages module',
    workschedule: 'Workschedule module',
    insurance: 'Insurance module',
    performance: 'Performance module'
  },
  hrbee_packages_descriptions: {
    assets: 'Assets module',
    employee: 'Employee module',
    feeds: 'Feeds module',
    recruitment: 'Recruitment module',
    vacations: 'Vacations module',
    wages: 'Wages module',
    workschedule: 'Workschedule module',
    insurance: 'Insurance module',
    performance: 'Performance module'
  },
  common: {
    yes: 'Yes',
    no: 'No',
    nodatafound: 'No data found',
    edit: 'Edit'
  },
  extra: {
    banktransfer: 'Bank transfer',
    date: 'Date',
    time: 'Time',
    type: 'Type',
    description: 'Description',
    cforcandidate: 'Comment for candidate',
    cbycandidate: 'Comments by candidate'
  },

  cancel_job: {
    cancel_job_vacancy: 'Cancel job vacancy',
    reason_of_job_cancelation:
      'Please write the reason of cancelation of job vacancy',
    candidates_will_be_informed:
      'All the candidates that has applied will be informed for the reason of cancelation',
    no_access: 'No access'
  },

  all_notifications: {
    on: 'on',
    at: 'at',
    mark_all_as_read: 'Mark all as read',
    no_notifications: "You don't have new notifications",

    invited_to_interview: 'invited you to interview for',
    approved_application: 'approved your application for',
    rejected_application: 'rejected your application for',
    rated_cv: 'rated your CV on',

    invite_interview: 'Invite interview',
    job_app_accepted: 'Job application accepted',
    job_app_rejected: 'Job application rejected',
    job_app_rated: 'Job application rated',

    applied_for: 'applied for',
    accepted_interview: 'accepted the interview',
    rejected_interview: 'rejected the interview',
    requested_vacation: 'requested vacation.',
    new_invoice: 'You have new invoice',
    for_your_company: ' for your company',
    approved_module: 'Hr Bee approved the module of ',
    rejected_module: 'Hr Bee rejected the module of ',

    new_application: 'New job application',
    interview_accepted: 'Interview accepted',
    interview_rejected: 'Interview rejected',
    vacation_request: 'Vacation request',
    invoice: 'Invoice',
    new_module: 'New module',
    reject_module: 'Rejected module',

    approved_vacation_request: 'approved your vacation request',
    department_lead_approved_vacation_request:
      "{departmentLeadName} approved {targetEmployeeName}'s vacation request, awaiting your decision",
    approved_vacation: 'approved you vacation',
    rejected_vacation_request: 'rejected your vacation request',

    vacation_approved: 'Vacation approved',
    vacation_rejected: 'Vacation rejected',
    vacation: 'Vacation',

    access_control_absence:
      'The system has found an absence from your work schedule'
  },

  salary_page: {
    primaryjob: 'Primary job',
    secondaryjob: 'Secondary job',
    terminationpay: 'Termination pay'
  },

  attendance: {
    map: 'Location coordinates',
    checkinlocation: 'Check In Location',
    checkoutlocation: 'Check Out Location',
    delete: 'Delete',
    get_reports_button: 'Get reports',
    work_duration: 'Work duration',
    pause_duration: 'Pause duration',
    checkin: 'Check In',
    checkout: 'Check Out',
    type: 'Type',
    duration: 'Duration',
    work: 'Work',
    pause: 'Pause',
    add_attendance: 'Add',
    add_attendance_description: 'Add working hours',
    today_attendances: 'Today attendances',
    today_schedule: 'Today schedule',
    weekly_schedules: 'Weekly schedules',
    monthly_attendances: 'Monthly attendances'
  },

  workschedule: {
    download_daily_reports: 'Download daily reports',
    download_monthly_reports: 'Download monthly reports',
    accesscontrolreports: 'Access Control Reports',
    nologs: 'There are still no data for this user',
    date: 'Date',
    checkin: 'Check In',
    checkout: 'Check Out',
    checkedin: 'Checked In',
    checkedout: 'Checked Out',
    byschedulecheckin: 'Schedule Check In',
    byschedulecheckout: 'Schedule Check Out',
    workinghours: 'Working hours',
    workedhours: 'Worked hours',
    absences: 'Absences',
    absencenotes: 'Absence notes',
    editabsence: 'Edit absence',
    reasons: 'Reasons',
    noreason: 'No reason given',
    deductfrompay: 'Deduct from pay',
    deductfrompayamount: 'Amount to deduct',
    markasresolved: 'Mark as resolved',
    details: 'Details',
    minutes: 'minutes',
    type: 'Type',
    totalworkinghours: 'Total working hours: ',
    totalabsencehours: 'Total hours absent: ',
    totalbreakhours: 'Total break hours: ',
    closedetails: 'Close details',
    addnewschedule: 'Add new schedule template',
    back: 'Back',
    name: 'Name',
    select_schedule_template: 'Select schedule template',
    workingschedule: 'Working Schedule',
    works: 'Works',
    nowork: 'No work',
    start: 'Start',
    end: 'End',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    update: 'Update',
    delete: 'Delete',
    noschedule: 'No schedule template, please add new',
    noemployee: "You don't have any employee added"
  },

  emp_pages: {
    no_general_vacations: 'There are no general vacations from company',
    departments: 'Departments',
    department: 'Department',
    position: 'Position',
    subdepartments: 'Sub departments',
    subsubdepartments: 'Sub sub departments',
    positions: 'Positions',
    nodresscode: 'No dress code',
    nodresscodedsc: 'Go to account settings and add new dress code',
    nodresscodewithsearch: 'No dress code found based on this filter',
    filter: 'Filter',
    clearfilter: 'Clear filter'
  },

  accsettings_alert: {
    old_pass_wrong: 'Old password should be correct!',
    pass_changed_success:
      'Password has been changed successfully, please log in again!',
    confirm_pass_wrong: 'Confirm password should be same as new password!'
  },

  employeeNavigation: {
    feeds: 'Feeds',
    profile: 'Profile',
    vacations: 'Vacations',
    salaries: 'Salaries',
    workingschedule: 'Working Schedule',
    workschedule: 'Work Schedule',
    myschedule: 'My Schedule',
    performance: 'Performance',
    events: 'Events',
    todos: 'To dos',
    companyorganogram: 'Company Organogram',
    dresscode: 'Dress code',
    regulation: 'Regulation'
  },

  employmentTypes: {
    full_time: 'Full time',
    part_time: 'Part time',
    remote: 'Remote',
    temporary: 'Temporary',
    contracted: 'Contracted',
    internship: 'Internship',
    seasonal: 'Seasonal',
    volunteer: 'Volunteer'
  },

  navigationCompany: {
    assets: 'Assets',
    asset_categories: 'Categories',
    support: 'Support',
    newsfeed: 'News Feed',
    recruitment: 'Recruitment',
    jobs: 'Jobs',
    interviews: 'Interviews',
    ratings: 'Ratings',
    blacklist: 'Black List',
    jobstemplate: 'Jobs Template',
    searchingemployees: 'Searching Staff',
    reports: 'Reports',
    employees: 'Staff',
    dashboard: 'Dashboard',
    allemployees: 'All Staff',
    documenttemplates: 'Document Templates',
    employeeContract: 'Employee Contracts',
    birthdays: 'Birthdays',
    performanceSettings: 'Performance Settings',
    workschedule: 'Attendance',
    workschedule_today: 'Today Attendances', // new entry
    all_employees: 'All Staff',
    schedule_template: 'Schedule Template',
    vacations: 'Leaves',
    vacationrequest: 'Leave Requests',
    publicholidays: 'Public Holidays',
    generalvacations: 'General Vacations',
    finances: 'Finances',
    employeesalaries: 'Employee Salaries',
    generatesalaries: 'Generate Salaries',
    wages: 'Compensations',
    timelineproject: 'Projects',
    training: 'Training',
    insurance: 'Insurance',
    performance: 'Performance',

    attendances_settings: 'Attendances Settings', // new entry
    performance_templates: 'Performance templates',
    all_employee_performances: 'All employee performances',

    paymentsettings: 'Payment settings',

    generatewages: 'Generate Wages',
    bonuses: 'Bonuses',
    employeeswages: 'Employees Wages',
    settings: 'Wages Settings'
  },

  alertscompany: {
    job_addeed: 'Your job added successfully',
    job_cantadded: 'Please fill in all required fields (*)',
    job_edited: 'Your job updated successfully',
    rated_added: 'You rated this candidate successfully',
    addcancelreason: 'Please add a cancel reason',
    invitedtointerview:
      'Invitation for interview has been sent successfully to candidate',
    cantadd: 'Please fill in all required fields (*)',
    rejectedcandidate: 'You rejected candidate from this position',
    blacklistedcandidate: 'You have blacklisted the candidate',
    hiredcandidate:
      'Successfully hired this candidate, go to employee module to finish the employment',
    potentialcandidate: 'Candidate added to the potential candidates list'
  },

  jobStatusTypes: {
    status: 'Job status',
    active: 'Active',
    draft: 'Draft',
    canceled: 'Canceled',
    finished: 'Completed',
    cancel_job: 'Cancel job'
  },

  performance: {
    add: 'Add',
    performances_list_for_section: 'Performances of this section:',
    no_sections_created_yet:
      'There is no performance section created yet for your position',
    section_no_performance:
      'There is no performance created yet for this section',
    select_month_to_see_ratings:
      'If you want to see ratings of performances please select month first',
    performances_employee_title: 'Rating performances',
    performances_employee_description:
      'Below you can find your rating performances based on sections',
    show_history: 'Show rating history',
    hide_history: 'Hide rating history',
    for_this_section_there_are:
      'For this section and for the selected month there are',
    performances_to_rate_employee:
      'performances that you can rate your employee',
    already_rated_for_this_month:
      'You have rated this employee for the selected month on this section, check the history now ->',
    please_select_month:
      'Please select month to rate your employee for this section',
    no_performances_for_this_section: 'No perfromances for this section yet',
    rating_history: 'Rating history',
    performance: 'Performance',
    rate_for_section: 'Rate for this section',
    performance_sections: 'performance sections',
    section: 'section',
    percentage_in_total_of_section: 'in total of selected section',
    of_section: 'of section',
    add_performance_for_section: 'Add performance section',
    rate_type: 'Rate type',
    list_of_performances_for_title: 'List of perfromances for selected section',
    list_of_performances_for_description:
      'List of performances for selected section',
    add_performance_for_section_title: 'Add performance for selected section',
    add_performance_for_section_description:
      'Add performance for selected section',
    performances: 'Performances',
    add_section_performance: 'Add Section',
    percentage_of_section: 'Percentage of section on performance template',
    in_total_perfomance: 'in total performance',
    add_performance_button: 'Add performance',
    add_performance_title: 'Create a performance criteria',
    add_performance_description: 'Contract with employees chanels',
    add_performance_section_title: 'Create a section',
    add_performance_section_description:
      'Create a section with performances criteria',

    rating_item_type_numbers_title: 'Rating measure performance',
    rating_item_type_numbers_description: 'Measure performance by rating',

    rating_item_type_scale_title: 'Rating measure performance',
    rating_item_type_scale_description: 'Measure performance by scale 1 to 5',

    rating_item_type_percentage_title: 'Comparability measure performance',
    rating_item_type_percentage_description:
      'This criteria can be used to measure level of achievement according comparability',
    target_you_achived: 'Target that you achived',
    target_you_have: 'Target that you have',
    taget_you_achived_percentage: 'Target that you achived in %',

    rating_item_type_text_title: 'Text box',
    rating_item_type_text_description:
      'Employees can write what they have to say in general',

    alert_select_type_of_rating: 'Please select one of the types of ratings',

    performance_templates: 'performance templates',
    performance_page_title: 'Employees performances',
    performance_page_description:
      'Below you can find your employees, you can choose one of them and rate performance',

    no_templates_available_for_current_position_of_employee:
      'There are no performance templates available for current position of this employee. Please go to Performance templates and create one.',

    month: 'Month',
    year: 'Year',
    text: 'Text'
  },

  month_value: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  },

  job_aplication_status: {
    applied_on: 'Applied on',
    rate_candidate: 'Rate',
    change_status: 'Change status',
    interview_details: 'Interview details',
    blacklisted_details: 'Details about blacklist',
    refuse_candidate_application_details:
      'Details about candidate application refusal.',
    reason_for_blacklist: 'Reason why you blacklisted this candidate',
    reason_for_decline: 'Reason why you refused candidate application',
    interview_category: 'Interview type',
    in_person_interview: 'In person interview',
    phone_call: 'Phone call',
    online_interview: 'Online interview',
    interview_date: 'Interview date',
    interview_time: 'Interview time',
    interview_description: 'Interview description',
    interview_comments: 'Interview comments',
    new_application: 'New application',
    rejected_candidate: 'Reject application',
    invited_to_interview: 'Invited to interview',
    blacklisted: 'Blacklist',
    accepted_interview: 'Accept interview',
    rejected_interview: 'Refuse interview',
    potential_candidate: 'Potential candidate',
    hired_candidate: 'Hired candidate',
    job_seeker_reference_letter: 'References',
    job_seeker_reference_letter_doesnt_exists: 'References not added',
    job_seeker_cover_letter: 'Cover letter',
    job_seeker_cover_letter_doesnt_exists: 'Cover letter not added'
  },

  company_jobs_page: {
    exportjobdetails: 'Export job details',
    need_to_be_approved: 'Job vacancy need to be approved by admin',
    approved: 'Job vacancy is approved and published',
    filterjobsbtn: 'Filter jobs',
    cancelbtn: 'Cancel',
    addnewjobbtn: 'Add new job',
    titlejob: 'Title',
    statusjob: 'Status of job: ',
    ongoing: 'Ongoing',
    pending: 'Pending',
    canceled: 'Canceled',
    completed: 'Completed',
    published: 'Published',
    typejob: 'Type of job',
    deadline: 'Deadline',
    applications: 'Applications',
    viewcandidates: 'View Candidates',
    editinterviewpanel: 'Edit Panel',
    selectinterviewpanelmember:
      'Choose which employees are part of this interview panel',
    editvacancy: 'Edit vacancy',
    deletevacancy: 'Delete',

    nojobspublished: "You don't have any published job yet",
    nojobsbysearch: 'No job with this search',
    searchjobplaceholder: 'Search job and hit enter',
    searchcandidateplaceholder: 'Candidate name & surname',
    namesurname: 'Name & Surname',
    email: 'Email address',
    phonenumber: 'Phone number (+383XXXXXXXX)',

    filterjobs: 'Filter jobs',
    filterjobsdsc: 'Preparing your jobs throw those filter',
    filterbystatus: 'Filter by status',
    filterbystatusph: 'Select status',
    filterbyyear: 'Filter by year',
    filterbyyearph: 'Select year',
    filterbymonth: 'Filter by month',
    filterbymonthph: 'Select month',
    filterbytype: 'Filter by type',
    filterbytypeph: 'Select type',
    applyfiltersbtn: 'Apply filters',

    filtercandidates: 'Filter candidates',
    filtercandidatesdsc: 'Preparing your list of candidates throw those filter',
    filterbygender: 'Filter by gender',
    filterbygenderph: 'Select gender',
    filterbyeducation: 'Filter by education',
    filterbyeducationph: 'Select education level',
    filterbyfieldofstudy: 'Filter by field of study',
    filterbyfieldofstudyph: 'Select field of study',
    filterbyskills: 'Filter by skills',
    filterbyskillsph: 'Select skill',
    filterbyrate: 'Filter by rate',
    filterbyrateph: 'Select rate',
    filterbylanguages: 'Filter by languages',
    filterbylanguagesph: 'Select language',
    filterbyyearsofexperience: 'Filter by years of experience',
    filterbyyearsofexperienceph: 'Select year of experience',
    filterbymotivationletter: 'Filter by motivation letter',
    filterbymotivationletterph: 'Show candidates with motivation letter',
    filterbyreferenceletter: 'Filter by reference letter',
    filterbyreferenceletterph: 'Show candidates with references letter',

    clearfiltersbtn: 'Clear filters',
    clearfilters: 'Clear filters',
    backbtn: 'Back',

    selectedcandidate: 'Selected Candidates',
    rejectedcandidate: 'Rejected Candidate',
    potentialcandidates: 'Potential Candidates',

    appliedon: 'Applied on: ',
    invitedforinterview: 'Invited for interview',
    interviewaccepted: 'Interview accepted by candidate',
    rejectedcandidatebycompany: 'Rejected candidate by company',
    rejectedinterview: 'Rejected interview by candidate',
    blacklistedcandidate: 'Blacklisted candidate',
    ratedcandidate: 'Rated candidate',
    hiredcandidate: 'Hired candidate',
    potentialcandidate: 'Potential candidate',

    sorrynojobapplications: 'Sorry, dont have any job application',

    titlecandidate: 'Title',
    birthday: 'Birthday',
    citycountry: 'City & Country',
    socialmedia: 'Social media: ',
    shortbio: 'Short biography: ',

    experience: 'Experience',
    noexperience: 'No experience added',
    education: 'Education',
    schoolname: 'School name',
    fieldofstudy: 'Field of study',
    fromupto: 'from - up to',
    levelofeducation: 'Level of education',
    file: 'File',
    noeducation: 'No education added',

    trainings: 'Trainings',
    institution: 'Institution',
    trainingcourse: 'Training / Course',
    notrainings: 'No trainings added',

    languages: 'Languages',
    language: 'Language',
    reading: 'Reading',
    understanding: 'Understanding',
    speaking: 'Speaking',
    writing: 'Writing',
    nolanguages: 'No languages added',

    itskills: 'IT skills',
    skill: 'Skill',
    level: 'Level',
    noitskills: 'No computer skills added',

    otherskills: 'Other skills',
    nootherskills: 'No other skills added',

    drivinglicence: 'Driving licence',
    nootherdrivinglicence: 'No other driving skills added',

    referenceletter: 'Reference letter',
    noreferenceletter: 'No reference letter',

    requiredreferenceandmotivation:
      'If you want reference and motivation letter please select',
    motivationletter: 'Motivation Letter',
    nomotivationletter: 'No motivation letter',

    rateeducation: 'Rate education',
    ratelanguages: 'Rate languages',
    rateexperience: 'Rate experience',
    profileexperience: 'Profile experience',
    generalknowledge: 'General knowledge',
    judgementcapability: 'Judgement capability',
    knowledgeaboutposition: 'Knowledge about position',
    logicalquestions: 'Logical questions',
    totalaveragerating: 'Total Average',
    ratecandidate: 'Rate candidate',
    noteforcandidate: 'Note for candidate',
    finaldecision: 'Final decision',

    publishjobbtn: 'Publish job',
    saveastemplatebtn: 'Save as template',

    previewofjobtemplate: 'Preview of your job template',
    titleofjobtemplate: 'Title of job template',

    editjob: 'Edit job',
    updatejob: 'Update job',

    viewblacklistedcandidates: 'View blacklisted candidates',
    noblacklistedcandidate: 'You dont have any blacklisted candidate',
    reason: 'Reason: ',
    details: 'Details',
    viewapplication: 'View application',
    removefromblacklist: 'Remove from blacklist',

    viewratedcandidates: 'View rated candidates',
    noratedcandidate: 'You dont have any rated candidate',

    viewinterviewcandidates: 'View interview candidates',
    nointerviewcandidate: 'You dont have any interview candidate',

    noinvitedcandidate: 'You dont have any invited candidate',
    noacceptcandidate:
      'No candidate has acceppted the invitation for interview',
    norejectcandidate: 'No candidate has rejected the invitation for interview',
    nointerviewcandidatewithsearch: "Can't find any candidate with that name",

    invitedinterview: 'Invited for interview',
    acceptinterview: 'Accepted interviews',
    rejectinterview: 'Rejected interviews',

    usethistemplate: 'Use this template',
    notemplate: 'You dont have any job template',

    noteaboutcandidate: 'Note about candidate',

    searchbyname: 'Search by name of candidate',
    searchbyjobtitle: 'Search by job title',

    decisionforcandidate: 'Decision for candidate',

    nextstage: 'Next stage',
    nextstagedc: 'Next stage',

    interviewcategory: 'Interview category',
    interviewcategorydc: 'Select interview category',
    interviewdate: 'Interview date',
    interviewtime: 'Interview time',
    'noteforcandidate-senttocandidate':
      'Note for candidate (will be sent to candidate)',
    'noteforcandidate-senttocandidatedc':
      'Please bring your laptop with you...',
    'noteforcandidate-private':
      'Note for candidate (will not be shown to candidate)',
    'noteforcandidate-privatedc':
      "This field will not be shown to candidate. Is's only for your company",
    invitetointerviewbtn: 'Invite to interview',

    rejectreason:
      'The candidate may be informed the reason for rejection from this position',
    rejectreasondc: 'Please type the rejection reason for this candidate...',

    applytemplate: 'Apply template',
    rejectcandidate: 'Reject candidate',
    blacklistcandidate: 'Blacklist candidate',

    blacklistreason: 'Reason for blacklisting candidate',
    blacklistreasondc: 'Please type the blacklist reason for this candidate...',

    makepotentialcandidate: 'Make potential candidate',
    hirethiscandidate: 'Hire this candidate',
    applyfilters: 'Apply filters',

    addnewtemplate: 'Add new template',
    doctemplates: 'Document templates',
    contracttemp: 'Contract templates',
    vacationstemp: 'Vacations templates',
    warninglettertemp: 'Warning letter templates',
    sorrynotemp: 'You don`t have any document template'
  },

  company_blacklist: {
    reason: 'Reason',
    jobseekername: 'Blacklisted name',
    jobseekeremail: 'Blacklisted email',
    jobseekerphonenumber: 'Blacklisted phone number',
    usersblacklisted: 'Users blacklisted',
    numberofusersblacklisted: 'Number of users blacklisted',
    viewusers: 'View users',
    createblacklist: 'Create blacklist',
    editblacklist: 'Edit blacklist',
    deleteblacklist: 'Delete blacklist',
    removeuserseditwarning:
      'Editing this blacklist with this information will cause these users to be unblacklisted, are you sure?',
    removeusersdeletewarning:
      'Deleting this blacklist will cause these users to be unblacklisted, are you sure?',
    userremoved: 'User successfully removed from blacklist',
    noblacklistedusers: 'No blacklisted users',
    createnewblacklistforremovedusers: 'Create new blacklist for these users',
    noblacklists: "You don't have any blacklists"
  },

  invite_manual_section: {
    invitemanual: 'Invite manual',
    invitejobseekermanual: 'Invite job seeker manually',
    experience: 'Experience',
    stillworking: 'Still working',
    notworking: 'Not working',
    cancel: 'Cancel',
    invitenow: 'Invite now'
  },

  salaryTypes: {
    salary_net: 'Net salary',
    salary_bruto: 'Gross salary',
    GROSS: 'Gross salary',
    NET: 'Net salary',
    null: 'Salary type'
  },

  VacationLeaveTypes: {
    yearly_leave: 'Yearly vacation',
    sick_leave: 'Sick leave',
    marriage_leave: 'Marriage leave',
    maternity_leave: 'Maternity leave',
    daily_leave: 'Daily leave',
    death_leave: 'Death leave',
    paternity_leave: 'Paternity leave',
    blood_donation_leave: 'Blood donation leave',
    compensation_leave: 'Compensation leave',
    overtime: 'Overtime',
    unpaid_leave: 'Unpaid leave'
  },

  assets: {
    image: 'Image',
    add: 'Add',
    change: 'Change',
    status: 'Status',
    available: 'Available',
    assigned: 'Assigned',
    in_maintenance: 'In Maintenance',
    retired: 'Retired',
    current_status: 'Current status',
    unique_identifier: 'Unique Identifier',
    identifier_input_mode: 'Identifier Input',
    identifier_mode_auto: 'Auto-generate',
    identifier_mode_manual: 'Manual entry',
    identifier_auto_placeholder: 'Identifier will be generated automatically',
    identifier_auto_help:
      'A unique identifier will be generated when you save the asset.',
    qr_code: 'QR Code',
    qr_code_description:
      'Scan this QR code to read the asset unique identifier.',
    qr_code_not_available: 'QR code is not available for this asset.',
    download_qr_code: 'Download QR Code',
    print_qr_code: 'Print QR Code',
    export_available: 'Export Available',
    export_assigned: 'Export Assigned',
    export_current_view: 'Export Current View',
    export_all: 'Export All',
    export_assets: 'Export to Excel',
    exporting_assets: 'Exporting...',
    created_date: 'Created Date',
    no_assets_to_export: 'There are no assets to export.',
    filter_by_status: 'Filter by status',
    all_statuses: 'All statuses',
    available_assets: 'Available assets',
    unassigned_assets: 'Unassigned Assets',
    assigned_assets: 'Assigned Assets',
    search_assets: 'Search assets by name or unique identifier',
    search_assets_placeholder: 'Search',
    search_results: 'Search Results',
    no_search_results: 'No assets found based on the current filters.',
    filter_by_category: 'Filter by category',
    clear_filters: 'Clear Filters',
    rows_per_page: 'Rows per page',
    deleted_category: 'Deleted category',
    select_asset_category: 'Select category asset',
    category_name: 'Category name',
    new_asset_category: 'New Category Asset',
    assets: 'Assets',
    asset: 'Asset',
    new_asset: 'Register Assets',
    assign_asset: 'Assign Asset',
    select_asset: 'Select Asset',
    assignment_date: 'Date Assignment',
    return_date: 'Return Date',
    return_asset: 'Return Asset',
    note: 'Note',
    no_data: 'There is no asset registered yet',
    title: 'Title',
    serial_number: 'Serial Number',
    edit_asset: 'Edit Asset',
    delete_asset: 'Delete Asset',
    assigned_to: 'Assigned To',
    asset_history: 'Asset History'
  },

  employee_module: {
    vacation: 'Vacation',
    contract_number: 'Contract number',
    startjoblaterthan: 'Started job not later than',
    calculateVacationUnusedDays: 'Calculate vacation days',
    deadline: 'Deadline',
    markedascompleted: 'Marked as completed',
    createtodo: 'Create to do',
    title: 'Title',
    description: 'Description',
    todos: 'To do',
    notodosfound: 'There is no todo created for this employee',
    phonenumber: 'Phone number',
    salaryamount: 'Salary amount',
    monthly_working_days: 'Monthly working days',
    job_description: 'Job description',
    accesscontrolid: 'Access control ID',
    requestdate: 'Request date',
    vacationyear: 'Vacation year',
    editdocumenttemplate: 'Edit document template',
    delete: 'Delete',
    download: 'Download',
    notapproved: 'Not approved',
    startdatevacation: 'Start date vacation',
    enddatevacation: 'End date vacation',
    totaldays: 'Total Days',
    total_days: 'Total days',
    selectvacationtemplate: 'Select vacation template',
    married: 'Married',
    not_married: 'Not married',
    addnewdocument: 'Add new document',
    expire: 'Expire date',
    expiry_date: 'Expiry Date',
    nogeneralvacations: 'There are no general vacations for your company',
    nogeneralvacationsdsc:
      'Please go to vacation module and add general vacations',
    yes: 'Yes',
    no: 'No',
    addthisemployeetowageslist: 'Add employee to wages list',
    issecondjob: 'Is it secondary job?',
    healthinsurancemonthlycost: 'Health Insurance Monthly Cost',
    newemployeebtn: 'Add new employee',
    noemployee: "You don't have any employee added",
    applyfilters: 'Apply filters',
    apply: 'Apply',

    addnewtemplate: 'Add new template',
    doctemplates: 'Document templates',
    contracttemp: 'Contract templates',
    vacationstemp: 'Vacations templates',
    warninglettertemp: 'Warning letter templates',
    sorrynotemp: 'You don`t have any document template',

    profilecv: 'Profile CV',
    employeeinfo: 'Employee Info',
    contract: 'Contract',
    contracthistory: 'Contract history',
    vacations: 'Vacations',
    performance: 'Performance',
    salary: 'Salary',
    warningletter: 'Warning Letter',
    otherdocuments: 'Other Documents',
    access: 'Access',

    personalinformation: 'Personal Information',
    accountinformation: 'Account Information',
    pw: 'Generate new password & send email',
    changepw: 'Change password',
    employeeworking: 'Employee is currently working in our company',
    female: 'Female',
    male: 'Male',

    bankinformation: 'Bank Information',
    bankname: 'Bank Name',
    banknumber: 'Bank account number',
    banknamedc: 'Name of bank...',

    emergencyinformation: 'Emergency Information',
    bloodgroup: 'Blood group',
    bloodgroupdc: 'Select blood group',
    contactperson: 'Contact person',
    contactpersondc: 'Contact person name...',
    contactpersonphone: 'Contact person phone',
    contactpersonphonedc: 'Contact person phone...',

    booktimeoff: 'Book time off',
    booktimeofffromcompany:
      'As a company you can book time off for an employee directly and aprove it',
    editvacation: 'Edit employee vacation',
    editvacationdc: "As a company you can edit an employee's time off",
    vacationtype: 'Vacation type',
    selectvacationtype: 'Select vacation type',
    vacationreplacedby: 'Replaced by',
    selectvacationreplacedby: 'Select replaced by',
    startdate: 'Start date',
    enddate: 'End date',
    halfday: 'Only need a half day off',
    reason: 'Reason',
    reasondc: 'Please type vacation reason...',

    contractstartdate: 'Contract start date',
    contractenddate: 'Contract end date',
    contractenddatetoggle: 'Contract indefinite term',
    indefiniteterm: 'Indefinite term',
    chooseposition: 'Choose position',
    from: 'From',
    upto: 'Up to',
    workplace_location: 'Workplace location',
    employmenttype: 'Employment type',
    current_address: 'Current address',
    country: 'Country',
    city: 'City',
    birthday: 'Birthday',

    contractinformation: 'Contract information',
    salaryinformation: 'Salary information',
    paymentcurrency: 'Payment currency',
    selectpaymentcurrency: 'Select payment currency',
    paymentcurrencyhelp:
      'Choose the currency used for this employee before generating payroll.',
    paymentcurrencyrequired: 'Payment currency is required.',
    salary_range_allowed: 'Allowed range: {min} - {max} {currency}',

    performancetools: 'Performance Tools',
    addnewperformance: 'Add new performance',
    editperformancebtn: 'Edit',
    deleteperformancebtn: 'Delete',
    performancerating: 'Rating measure performance',
    performanceratingdc: 'Measure performance by rating',
    noperformance: "You don't have any performance added",
    noperformancedc:
      'In order to add a user performance review, first you need to create a configuration for your performances',
    performancename: 'Title',
    performanceratinginterval: 'How often should employees be rated?',
    selecttypeperformance: 'Select a type of performance',
    performancetype: 'Performance type: ',
    rateperformance: 'Rate performance',
    yearforrating: 'Year for rating',
    yearforratingdc: 'Select year for rating',
    monthforrating: 'Month for rating',
    monthforratingdc: 'Select month for rating',

    addemployees: 'Add employees',
    addemployeesdsc:
      'Add your employees throw those options by clicking buttons',
    byrecruitment: 'By recruitment',
    manual: 'Manual',

    nojobseekerwithhiredstatus: 'No jobseeker with hired status found',

    personalinfo: 'Personal information',
    accinfor: 'Account information',

    idcardno: 'Employee Company ID',
    idcardnodc: 'ID card number',
    department: 'Department',
    position: 'Position',
    accemail: 'Account email user',
    startjob: 'Start job',
    phone: 'Phone number',
    personalid: 'Personal ID',

    hirethisemployee: 'Hire this employee',

    filteremployees: 'Filter employees',
    clearfilters: 'Clear filters',
    filteremployeesdc: 'Preparing your list of employees throw those filter',

    filterbydepartment: 'Filter by department',
    filterbyposition: 'Filter by position',
    filterbygender: 'Filter by gender',
    filterbycity: 'Filter by city',

    generatesalary: 'Generate salary',
    salaryfor: 'Salary for',
    salarytype: 'Salary Type',
    grosssalary: 'Gross salary',
    taxes: 'Taxes',
    rankjob: 'Rank of job',
    primaryjob: 'Primary job',
    secondaryjob: 'Secondary job',
    date: 'Date',
    contribution: 'Contribution',
    totaltax: 'Total tax',
    netsalary: 'NET salary',
    nosalarygenerated: 'This employee doesn`t have any salaries generated',

    editmonthly: 'Edit monthly report details',
    selectyear: 'Select year',
    selectmonth: 'From month',
    formonth: 'For month',
    selecttomonth: 'To month',
    isthissecondaryjob: 'Is this secondary job?',
    advancedpayment: 'Advanced payment',
    leavewithoutpayment: 'Leave without payment',
    bonuspayment: 'Bonus payment',
    savereport: 'Save raport',

    nodocuments: 'You don`t have any document addedd',

    selectcontract: 'Select contract',
    selectwarningletter: 'Select warning letter from your document templates',

    nameandsurname: 'Name & Surname',
    personalID: 'Personal ID',
    employeeID: 'Employee ID',
    address: 'Address',
    startdatecontract: 'Start date contract',
    enddatecontract: 'End date contract',
    ceo: 'CEO',
    companyname: 'Company name',
    fiscalnumber: 'Fiscal number',
    companyaddress: 'Company address',
    companycity: 'Company city',
    headofhr: 'Head of HR',

    contracttermination: 'Termination of Contract',
    contractterminationbtn: 'Terminate Contract',
    editcontractterminationbtn: 'Edit Contract Termination Details',
    contractterminationgrosspay: 'Termination Gross Pay',
    contractterminationreason: 'Reason for Termination',

    leavehistory: 'Leave history for the year',
    noleaves: 'No leaves for this year',

    genderstatistics: 'Gender statistics',
    marriagestatistics: 'Marriage statistics',
    nationalitystatistics: 'Nationality statistics',
    employmenttypestatistics: 'Employment type statistics',
    activestatusstatistics: 'Active status statistics',
    averageSalary: 'Average salary statistics'
  },

  alerts_employee_module: {
    update_document_template: 'Document template updated successfully',
    update_employee: 'Employee information updated successfully',
    vacationfromcompany: 'Book time off has successfully saved',
    vacationdaysexist: 'Already requested dates for vacation',
    rateperformance: 'You rated performance successfully for this candidate',
    newemployee: 'Successfully hired new employee',
    emailunique: 'This email is already taken',
    deletetemplate: 'Template deleted successfully',
    somethingwentwrong: 'Something went wrong, please try again',
    templateadded: 'Document template added successfully'
  },

  payroll_currency: {
    confirm_single_employee_mismatch:
      'This employee uses a different payment currency. Continue with conversion?',
    confirm_multiple_employee_mismatch:
      'Some employees use a different payment currency. Continue with conversion?',
    shown_in: 'Shown in',
    converted_from: 'Converted from',
    conversion_rate: 'Conversion rate'
  },

  inputs_employee_module: {
    title: 'Title',
    type: 'Type',
    selecttype: 'Select type',
    templatecolumns: 'Number of columns'
  },

  employee_access: {
    access: "Set this employee's access",
    selectpackage: 'Select package',
    accesstype: 'Access Type',
    accessdepartments: 'Access to Departments',
    selectaccesstype: 'Select access type',
    accessread: 'Read',
    accesswrite: 'Write',
    isadmin: 'Is Administrator'
  },

  alerts_employee_access: {
    nopackageselected: 'You must select a package',
    accessupdated: 'Employee access has been updated'
  },

  vacations_module: {
    print: 'Print',
    vacationyear: 'Vacation year',
    vacationmonth: 'Vacation month',
    publicholidays: 'Public Holidays',
    nopublicholiday: 'No public holiday added',
    addnewholiday: 'Add new public holiday',
    editholiday: 'Edit public holiday',
    edit: 'Edit',
    delete: 'Delete',
    createholiday: 'Create new holiday date',
    createholidaysdsc: 'Type name and date of holiday to create new holidays',
    holidayname: 'Holiday name',
    holidaydate: 'Holiday date',

    right_to_use_next_year: 'Left days of vacation can use next year?',

    generalvac: 'General Vacation',
    addnewvac: 'Add new Vacation',
    editvac: 'Edit vacation',
    createvacation: 'Create New Vacation',
    createvacationdsc: 'Fill fields and create new vacation for your employees',

    replacedby: 'Replaced by',
    vacationname: 'Vacation Name',
    totaldays: 'Total Days',
    foryear: 'For year',
    accumulatemonthly: 'Accumulate monthly',
    halfdays: 'Half Days',
    onetimetake: 'One time take',
    extradays: 'Get Extra Days',
    year: 'Every Year',
    day: 'Every Day',
    righttousemonth: 'Right to use month',
    righttouseyear: 'Right to use year',
    howcanuse: 'How can use this Vacation',
    hide: 'Hide',
    roles: 'Roles',

    addvacation: 'Add Vacation',
    nogeneralvacations: 'No general vacation added',

    days: 'Days',
    righttousenextyear: 'Can use next year',

    manageempvacations: 'Manage Employee Vacations',
    onvacation: 'On vacation',
    pendingdepartmentleadapproval: 'Pending Department Lead Approval',
    pendinghrapproval: 'Pending HR Approval',
    approved: 'Approved',
    rejected: 'Rejected',
    requestdays: 'Request Days',
    requestedhalfdays: 'Requested half days',
    requestedhalfdaysam: 'AM',
    requestedhalfdayspm: 'PM',
    vacationtype: 'Vacation type',
    reason: 'Reason',
    decision: 'Decision',
    approvebtn: 'Approve',
    rejectbtn: 'Reject',
    nopendingdepartmentleadvacations:
      'No vacations pending department lead approval',
    norejectedvacations: 'No rejected vacations',
    nopendinghrapprovalvacations: 'No vacations pending HR approval',
    noapprovedvacations: 'No approved vacations',

    info: 'Info',

    rejectnotifycandidate: 'Notify candidate of rejection',

    basevacation: 'Base Definition',
    basevacationdc:
      'You are editing a vacation specifically for one employee, this vacation is based on:',

    ispaid: 'Is paid',
    ispaidontermination: 'Paid on contract termination',
    dailypaypercentage: 'Percentage of daily pay'
  },

  alerts_vacations_module: {
    dateunique: 'This date alredy exists as public holiday',
    added: 'Successfully added new public holiday',
    deleted: 'Successfully deleted public holiday',
    updated: 'Successfully updated public holiday',

    smthwrong: 'Something went wrong, please try again',

    addedvac: 'Successfully added new general vacation',
    updvacation: 'Successfully updated general vacation',
    delvacation: 'Successfully deleted general vacation',

    approvedvacation: 'Vacation request approved successfully',
    rejectedvacation: 'Vacation request rejected successfully',
    rejectreason: 'Please type reject reason first',
    deletedvacation: 'Vacation request deleted successfully'
  },

  payment_settings: {
    paymentsettings: 'Payment Settings',
    packages: 'Packages',
    availablemodules: 'Available Modules',
    activemodules: 'Active Modules',
    invoices: 'Invoices',
    activemodulesdsc: 'List of modules that you are using currently',
    noactivemodules: 'No active modules for your company',
    'euro-peremployee': '€ / per employee',
    availablemodulesdsc:
      'List of modules that are available and you can use them',
    addmodule: 'Add Module',
    allmodulesasigned:
      'All Hrbee modules are activated for your company / institution',

    invoiceno: 'Invoice number',
    paymentmethod: 'Payment method',
    amount: 'Amount to be paid',
    details: 'Details',
    noinvoice: 'You dont have any invoice yet'
  },

  'payment_settings-alerts': {
    packagerequestsent: 'Package request has been sent'
  },

  account_settings: {
    rate_by: 'Section should be rated from',
    rate_frequency: 'Rate frequency',
    staff_category: 'Staff Category',
    pay_tax: 'Taxes payment',
    pay_tax_short: 'Taxes',
    pay_contribution: 'Contribution payment',
    pay_contribution_short: 'Contribution',
    job_description: 'Job description',
    belongstodepartment: 'Belongs to department',
    belongstosubdepartment: 'Belongs to sub department',

    api: 'API',
    apidsc: 'Generate your API key and use some of endpoints',
    apigeneratebutton: 'Generate API key',
    apiGetEmployees: 'Use this URL to fetch list of your employees',
    apiGetVacations: 'Use this URL to fetch list of vacations',
    apiGetPerformances: 'Use this URL to fetch list of performances',

    accountsettings: 'Account Settings',
    businessinfo: 'Business Information',
    businessinfodsc: 'Change your company main information details below',
    mainpayrollcurrency: 'Main payroll currency',
    selectmainpayrollcurrency: 'Select company currency',
    mainpayrollcurrencyhelp:
      'This currency is used as the payroll base for salary generation and reporting.',
    mainpayrollcurrencyrequired: 'Main payroll currency is required.',
    businesslogo: 'Business Logo',
    businesslogodsc: 'Below you can upload your business logo',
    businesspassword: 'Business Password',
    businessdresscode: 'Business Dress Code',
    businessregulation: 'Business Regulation',
    businessorganogram: 'Business Organogram',
    generalsettings: 'General Settings',
    integrations: 'Integrations',
    integrationsaccesscontrol: 'Access Control Integration',
    integrationsaccesscontroldc:
      "Connect your API to track your employee's checkout/checkin times",
    integrationsaccesscontroldocumentation: 'View API Documentation',
    integrationsauthtype: 'Authentication type',
    integrationsauthendpoint: 'Authentication endpoint',
    integrationsauthusername: 'Authentication username',
    integrationsauthpassword: 'Authentication password',
    integrationsauthtoken: 'Authentication token',
    integrationsapiendpoint: 'API endpoint',
    localedc:
      'This setting will determine what language emails sent to your employees will be in',
    employeeaccesses: 'Employee Accesses',
    attachcertificate: 'Attach Certificate',
    editattachcertificate: 'Edit Certificate',
    seecertificate: 'See certificate',
    save: 'Save',
    attachbusinesscertificate: 'Attach Business Certificate',
    addbusinessregulation: 'Add business regulation',
    addbusinessregulationinfo: 'Upload your business regulations',

    profilelogo: 'Profile Logo',
    businesscategorylogo: 'Business Category Logo',
    changelogo: 'Change logo',
    uploadlogo: 'Upload logo',

    fileaccepted: 'File accepted: ',
    maxfile: 'Max file size: ',

    changepassword: 'Change password',
    changepassworddsc:
      'If you require to change your account password, you can do it here',
    currentpassword: 'Current Password',

    createdepartment: 'Create Department',
    createposition: 'Create Position',

    departmentname: 'Department Name',
    departmentclass: 'Department Class',
    reportto: 'Report To',
    adddepartment: 'Add Department',

    positionname: 'Position Name',
    choosedepartment: 'Choose Department',
    choosesubdepartment: 'Choose Sub Department',
    addposition: 'Add Position',
    addsubdepartment: 'Add sub department',
    addsubsubdepartment: 'Add sub sub department',

    edit: 'Edit',
    delete: 'Delete',

    noposition: 'There are no position created in this department',

    updatedepartment: 'Update Department',
    updateposition: 'Update Position',

    uploaddresscode: 'Upload your business Dress Code',
    adddresscode: 'Add new dress code',
    back: 'Back',
    nodresscode: 'No dress code',
    nodresscodedsc:
      'Go to add new dress code and create dress code for your company',

    employeestatistics: 'Employee Statistics',

    employeereports: 'Employee Reports',
    employeereportsdc:
      'Generate an excel file containing all company employee data',

    expiredcontract: 'Employee with expired contract',
    employeecontracts30: 'Employee contracts that end in 30 days',
    employeecontracts60: 'Employee contracts that end in 60 days',
    employeecontracts_intern_7: 'Internship contracts that end in 7 days',
    employeecontracts_intern_15: 'Internship contracts that end in 15 days',
    employeecontracts_all_normal: 'All normal contracts',
    employeecontracts_all_interns: 'All internship contracts',
    employeecontracts_probation_7: 'Probation contracts that end in 7 days',
    employeecontracts_probation_16: 'Probation contracts that end in 16 days',
    employeecontracts_all: 'All employee contracts',
    nodatafound: 'No data found',

    employeeleavereports: 'Employee Leave Reports',
    employeeleavereportsdc:
      'Generate an excel file containing all company employee leave data',

    employeepromotionsreports: 'Employee Promotions Reports',
    employeepromotionsreportsdc:
      'Generate an excel file containing all company employee promotion data',

    recruitmentreports: 'Recruitment Reports',
    recruitmentreportsdc:
      'Generate an excel file containing recruitment statistics',

    downloadreport: 'Download Report',
    downloadreportall: 'Download Full Report',
    downloadleavesreport: 'Download Leaves Report',
    downloadunusedleavesreport: 'Download Unused Leaves Report',

    noexpiringcontracts: 'No contracts expiring in the next 60 days',

    email_for_wages:
      'Do you want your employee to receive emails when wages are generated?',
    email_for_wages_info:
      'This setting will determine if your employees will receive emails when wages are generated',
    language_employee_emails: 'Select language for employee emails',
    email_for_birthdays:
      'Do you want your employee to receive emails for birthday?',
    email_for_birthday_info:
      'This setting will determine if your employees will receive emails for birthday. The email will be sent from HrBee in name of your company',
    email_for_work_anniversary:
      'Do you want your employee to receive emails for work anniversary?',
    email_for_work_anniversary_info:
      'This setting will determine if your employees will receive emails for work anniversary. The email will be sent from HrBee in name of your company',
    anniversary_email_content: 'Content of email for work anniversary',
    vacation_weekend_count: 'Allow vacation weekend',
    vacation_weekend_count_info:
      'This setting will determine vacations settings',
    contracts_notification_and_read:
      'Allow employee to mark regulations as readed',
    contracts_notification_and_read_info:
      'Thiss setting will determine If you want to allow employees to mark regulations as readed'
  },

  'account_settings-alerts': {
    attachedfile: 'Business certificate attached successfully',
    somethingwentwrong: 'Something went wrong, please try again',
    companyinfoupdated: 'Company information updated successfully',
    fillrequiredfields: 'Please fill out all required fields',

    maxfileerror: 'Max file size is 5 MB, please choose another file',
    logosaved: 'Logo uploaded successfully',
    noimage: 'No image selected, please choose an image',
    passwordchanged: 'Your account password changed successfully',
    regulationupdated: 'Business regulation updated successfully',
    regulationsaved: 'Business regulation saved successfully',
    dresscodesaved: 'New business dress code added successfully',
    departmentsuccess: 'Department added successfully',
    subdepartmentsuccess: 'Sub department added successfully',
    subsubdepartmentsuccess: 'Sub sub department added successfully',
    positionsuccess: 'Position added successfully',

    departmentupdated: 'Department updated successfully',
    subdepartmentupdated: 'Sub department updated successfully',
    positionupdated: 'Position updated successfully',
    trytodelete: 'Departments with job positions cannot be deleted',
    deletedepartment: 'Department deleted successfully',
    deleteposition: 'Position deleted successfully',
    deletedresscode: 'Dress code deleted successfully'
  },

  feeds_module: {
    nodresscode: 'No dress code',
    cancelfilters: 'Cancel',
    comingsoon: 'Coming Soon',

    birthdaymonth: 'Birthday Month',
    choosebirthday: 'Choose Birthday',
    noemployeebasedonthisfilter: 'No employee based in this filter',
    chooseposition: 'Choose position',
    email: 'E-mail',
    mobile: 'Mobile',

    createevent: 'Create Event',
    createeventdsc: 'Create an event that will show to your employee',
    date: 'Date',
    location: 'Location',
    invited: 'Invited',
    note: 'Note',
    postevent: 'Post Event',
    editevent: 'Edit Event',
    updateevent: 'Update Event',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    noevents: 'No Events',

    share: 'Share',
    addlink: 'Add Link',
    image: 'Image',
    paragraph: 'Paragraph',
    deletepost: 'Delete post',
    nofeeds: 'There are no published feeds yet',

    organogramofcompany: 'Organogram of company',
    dresscode: 'Dress code',
    regulations: 'Regulations',
    contacts: 'Contacts',
    events: 'Events',
    birthdays: 'Birthdays',
    chat: 'Chat',

    hrdepartment: 'Human Resource of this Department',
    hrdepartmentdsc:
      'Preparing your list of employee through selected department',
    noemployeeinthisdepartment: 'There are no employee in this department',

    feedpermissions: 'Feed permissions',
    editfeedpermissions: 'Who can post on the feed?',
    editfeedpermissionsbtn: 'Edit feed permissions',

    sharedwithdepartments: 'Shared with departments'
  },

  'feeds_module-alerts': {
    somethingwentwrong: 'Something went wrong, please try again',
    deleteevent: 'Event deleted successfully',
    updateevent: 'Event updated successfully',
    requiredfields: 'Please fill up all required fields',
    addevent: 'Event added successfully',

    typesomething: 'Please type something first',
    addpost: 'Post added successfully',
    deletepost: 'Post deleted successfully'
  },

  monthsvalue: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  },

  insurance_module: {
    employees_insurances: 'Employees Insurances',
    employees_insurances_description:
      'Below you can find all your employees, you can choose one of them and manage insurance data',
    noemployeefound:
      'No employee found, please go to employee module and add your employees',
    for_employee: 'For employee',
    insurances_for_employee_not_found: 'No data found',
    full_name: 'Full name',
    total_insurance: 'Total insurance',
    company_insurance: 'Payment from company',
    employee_insurance: 'Payment from employee',
    relation: 'Relation',
    for_employee_ralations: 'For employee relations',
    insurances_for_employee_relations_not_found: 'No data found'
  },

  wages_module: {
    deletegeneratedwages: 'Delete generated wages',
    grosssalaryByHours: 'Gross salary by hours',
    export_language: 'Select Language',
    description: 'Description',
    primaryjob: 'Primary job',
    secondaryjob: 'Secondary job',
    joindate: 'Join date',
    settingsfinances: 'Settings wages for your company',
    'tax0-80': 'Tax 0-250',
    'tax80-250': 'Tax 0-250',
    'tax250-450': 'Tax 250-450',
    'tax>450': 'Tax > 450',
    contribution: 'Contribution',
    overtime: 'Overtime',
    wardship: 'Wardship',
    weekendholidays: 'Weekend Holidays',
    savefinancialsettings: 'Save wages settings',

    addemptowageslist: 'Add new employee to wages list',
    back: 'Back',
    empwageslist: 'Employee wages list',
    empwageslistdsc:
      'Below you can find list of employees that are added in wages list',
    edit: 'Edit',
    delete: 'Delete',
    noempinwageslist: 'There are no employee in wages list, please add new now',

    generatewages: 'Generate Wages',
    taxdeclaration: 'Tax Declaration',
    export: 'Export',
    salaryfor: 'Salaries for',
    bonusfor: 'Bonuses for',
    grosssalary: 'Gross salary',
    totalsalary: 'Total salary',
    healthinsurancecost: 'Insurance gross',
    healthinsurancecostneto: 'Insurance neto',
    rankofjob: 'Rank of job',
    absencededuction: 'Absence deduction',
    leavededuction: 'Leave deduction',
    totaltax: 'Total tax',
    netsalary: 'NET salary',
    nowagesgenerated: 'No wages generated',
    nobonuses: 'No bonuses',
    generatemonthly: 'Generate monthly employees wages',
    selectyear: 'Select year',
    selectmonth: 'Select month',
    editwages: 'Edit wage of selected employee',
    editbonusof: 'Edit bonus of',
    advancepayment: 'Advance payment',
    leavewithoutpayment: 'Leave without payment',
    bonuspayment: 'Bonus payment',
    mealspayment: 'Meals payment',
    workinghours: 'Working hours',
    workhourspermonth: 'Work hours per month',
    priceperhour: 'Price per hour',
    grosssalarybyhours: 'Gross salary by hours',
    'overtime-nightshift': 'Overtime - night shift',
    save: 'Save',

    filter: 'Filter',
    clearfilter: 'Clear filter',
    filterwages: 'Filter wages by year and month',
    closeallwages: 'Close wages',
    no_salaries_available_for_period:
      'No salaries available for {month} of {year}',

    salarybonus: 'Salary bonus',
    grosssalarybonus: 'Gross salary bonus',
    grosssalarytotal: 'Gross salary total',
    bonusnote: 'Bonus note',
    salaryincrements: 'Salary increments',
    incrementsalaryeverynyears: 'Increment salary every',
    basesalary: 'Base gross salary',
    incrementsalarybyamount: 'Increment by amount',
    salaryincrementedbyvalue: 'Current increment value',
    years: 'year(s)',
    onmonth: 'On month',

    extra: 'Extra',

    closed: 'Closed',

    uploadbonuses: 'Upload bonuses',
    deletebonuses: 'Delete bonuses',

    selectbonusexcel: 'Select a Microsoft Excel file to upload'
  },

  'wages_module-alerts': {
    somethingwentwrong: 'Something went wrong, please try again',
    settingsupdated: 'Wages settings updated successfully',
    deletefromwageslist: 'Employee deleted from wages list',

    wagedelete: 'Wage deleted successfully',
    wageupdated: 'Wage updated successfully',
    wagesgenerated: 'Wages generated successfully',
    alredygenerated: 'Already generated wages for this month'
  },

  noaccesspages: {
    nopackage: "You don't have access to this package",
    nopackagedsc:
      'In order to have access to this page YOU or company you belong should activate this package',
    viewpackages: 'View packages',

    noaccesstopage: "You don't have access to this page",
    noaccesstopagedsc:
      'In order to have access to this page YOU need to activate your account by email verification'
  },
  aboutus_page: {
    aboutus: 'About Us',
    aboutusdsc1:
      'We are focused on providing services that help companies increase their profits by managing the performance of their staff.',
    aboutusdsc2:
      'Digitization of human resource management processes is very important for achieving success and developing companies.',
    aboutusdsc3:
      'Therefore, through the Hr bee Management platform, entrepreneurs will be able to manage employees through several modules that the platform offers.',
    aboutusdsc4: 'There are more than 320+ fully digitized processes.',
    aboutusdsc5:
      'Knowing the capacities of human resources that enterprises have, it will be easier for them to manage and plan the necessary resources to achieve the goals that enterprises have set for themselves.',
    aboutusdsc:
      'Working in the human resources office and seeing that most of his time was taking over the day-to-day technical processes .... He stopped for a moment and began to think! Should have a choice? What if I was like a bee? Yes, a bee that despite having a large number of workers does everything best. There I begin everything to proceed first as a case study within Kosovo to develop further in the Region and then towards Europe. YYes, we have built digital bees to help each of you manage employees and have time for important strategic processes for their company. Bee digital.',

    ourteam: 'Our Team',
    ourteamdsc1:
      'The Hr bee Management team is composed of the following areas:',
    ourteamdsc2:
      'Management, Human Resources, Legal and Information Technology',
    ourteamdsc3: 'With an average work experience above',
    ourteamdsc4: '18+ years',
    ourteamdsc:
      'Digjitalizimi i proceseve për menaxhimin e burimeve njerzore është shumë i rëndësishëm për arritjen e sukseve dhe zhvillin e ndërmarrjeve Andaj përmes platformës hr bee, ndërmarrësit do të mund që të menaxhojnë punonjësit përmes disa moduleve të cilat platforma i ofron. Duke njohur kapacitetet e burimeve njerzore që ndërmarrjet kanë, do ta kenë më të lehtë që të menaxhojnë edhe të planifikojnë resurset e nevojshme në arritjen e qëllimeve që ndërmarrjet i kanë vënë vehtës.',

    ourpartners: 'Our Partners',
    ourpartnersdsc: 'Some of our partners in different countries operate...',

    ourclients: 'Our Clients',
    ourclientsdsc: 'Some of our clients that use HRBee Management',

    weoperatein: 'We operate in!',
    weoperateindsc1: 'Currently we are operating in Kosovo and Albania',
    weoperateindsc2: 'We are also working on launching the platform at Europen',
    weoperateindsc3: 'If you want to be our partner for you country',
    clickhere: 'click here',

    contactus: 'Contact us',
    contactusdsc1:
      'Feel free to contact us for any questions or concerns you may have.',
    contactusdsc2: 'Always happy to talk to you. Send us a mesage',

    sendmsgbtn: 'Send message',

    address: 'Address',
    mainoffice: 'Our main office address',
    information: 'Information',
    support: 'Support',
    franchizes: 'Franchizes'
  },
  product_page: {
    featuresbtn: 'Features',
    createaccountbtn: 'Create account',
    backbtn: 'Back',

    company: 'Companies',
    companydsc:
      'Digitalization of human resource management processes is very important for the achievement of success and the development of enterprises. Therefore through the hr bee platform, companies will be able to manage employees through some of the modules that the platform offers.',
    companydsc1:
      'By recognizing the human resource capacities that enterprises have, it will be easier for them to manage and plan the necessary resources in achieving the goals that enterprises have set for themselves.',

    jobseeker: 'Job seekers',
    jobseekerdsc1:
      'Finding a job today is very difficult and sometimes it seems almost impossible.',
    jobseekerdsc2:
      'Digitization today is a very important tool to find that job.',
    jobseekerdsc3:
      "Therefore, by digitizing the jobseeker's profile, you first create a standard for your profile, which is important for the further job application process. You only need to enter your data once in the system and then apply for different jobs with just one click.",

    signupandcreatecv: 'Signup and create your CV',
    signupandcreatecvdsc1:
      'In order to apply for jobs you need to have a Job seeker account with HRBEE.',
    signupandcreatecvdsc2:
      "As soon as you signup you'll have the options to create your online CV as well as to download it in a template we've prepared..",

    findjobandapply: 'Find job and apply',
    findjobandapplydsc1:
      'Hr Bee facilitates the job search process for jobseekers.',
    findjobandapplydsc2:
      'And it enables them to apply for vacancies with just one click or by saving that job to apply later.',

    wekeepupdated: 'We keep you updated about your application',
    wekeepupdateddsc1:
      'Hrbee enables the jobseeker to interact with companies for the position he / she has applied for.',
    wekeepupdateddsc2:
      'This includes notices about your job application. You will receive notifications to be invited to the interview, notices even when your application is rejected and even if you qualify to become an employee of that company, you will have your account as an employee.',

    feedmodule: 'Feeds module',
    feedmoduledsc:
      'The feeds module facilitates intra-company communication between you and your employees in real time',
    feedmodule1: 'INTERACT WITH EMPLOYEES',
    feedmodule2: 'Interact with your employees within the company',
    feedmodule3:
      'Communication and interaction between employees within the company is of particular importance. Through this module you can distribute important information to your employees while maintaining the privacy of that information',

    recruitmentmodule: 'Recruitment module',
    recruitmentmoduledsc:
      'The recruitment module facilitates the recruiting process and helps you to make your selection of staff according to the criteria you have chosen. Through this module, the recruitment process will be easier, more efficient and 100% faster than before',
    recruitmentmodule1: 'CREATING A  COMPETITION',
    recruitmentmodule2:
      'Create and manage applications for your company vacancies',
    recruitmentmodule3:
      'Through the recruitment module the process of creating / announcing a vacancy and its management will be much simpler. You just need to fill in the required standardized fields and your notice will be published. There is also a template for the description of your competition',
    recruitmentmodule4: 'INTERVIEWS',
    recruitmentmodule5: 'Select and invite candidates for interview',
    recruitmentmodule6:
      "Selecting a candidate for an interview will be much easier and simpler. After evaluating the candidate's CV you can send the interview invitation, you just need to specify: the day, the time of the interview the candidate and the candidate will automatically receive the interview notice from you",
    recruitmentmodule7: 'RATINGS',
    recruitmentmodule8: 'Evaluate candidates based on position criteria',
    recruitmentmodule9:
      'valuating candidates during the interview is also a very important element and will help you at the end of the process make it clearer and easier to select the most successful candidate for that job',

    employeesmodule: 'Employees Module',
    employeesmoduledsc:
      'A company cannot develop without proper human resource management. Human resource management includes many processes that we have included in this module',
    employeesmodule1: 'EMPLOYEES',
    employeesmodule2: 'Manage employees',
    employeesmodule3:
      'Manage all human resource processes digitally and interactively with company employees',
    employeesmodule4: 'DOCUMENTS',
    employeesmodule5: 'Manage each employee documents',
    employeesmodule6:
      'All the staff documents / files will be archived digitally for whom that individual separately',
    employeesmodule7: 'WORK DETAILS',
    employeesmodule8: 'Manage employee work history',
    employeesmodule9:
      'The development history of any employee will be stored digitally and accessible to both parties',
    employeesmodule10: 'HIRE EMPLOYEES',
    employeesmodule11: 'Employee registration',
    employeesmodule12:
      'Employee registration can be done through the recruitment module or by manually registering the employee in the company',

    workingschedule: 'Working Schedule Module',
    workingscheduledsc:
      'Management of schedules and putting staff in place and the right time is of great importance in the development of processes within the company',
    workingschedule1: 'WORK SCHEDULE SETTINGS',
    workingschedule2: 'Creating schedules and shifts for employees',
    workingschedule3:
      'Managing and planning work hours for employees is of particular importance for day-to-day processes within the company',
    workingschedule4: 'WORK SCHEDULE',
    workingschedule5: 'Manage employees work schedule',
    workingschedule6:
      'Working hours can be managed by departments or by employee within departments',

    vacationmodule: 'Vacations Module',
    vacationmoduledsc:
      "Module vacation help you manage and tune your staff holidays with your company's activities",
    vacationmodule1: 'VACATION SETTINGS',
    vacationmodule2: 'Create and manage vacation types',
    vacationmodule3:
      "Define the types and days of holidays according to the company's specifications",
    vacationmodule4: 'VACATIONS SETTINGS',
    vacationmodule5: 'Define public holidays',
    vacationmodule6:
      'Define official holidays by countries and religious beliefs',
    vacationmodule7: 'VACATIONS REQUESTS',
    vacationmodule8: 'Vacation request management',
    vacationmodule9:
      "You can manage your employees' vacation requests according to the priorities they may have",
    vacationmodule10: 'VACATIONS ALLOWANCES',
    vacationmodule11: 'Check the list of approved / rejected vacations',
    vacationmodule12:
      'You can see the vacation days for which employee according to the types of vacation',

    wagesmodule: 'Wages Module',
    wagesmoduledsc:
      'This module makes it easy for you to calculate and generate all payment processing for your employees',
    wagesmodule1: 'WAGES SETTINGS',
    wagesmodule2: "Generation and updating of employees' salary",
    wagesmodule3: 'Generating payroll list and editing for pay execution',
    wagesmodule4: 'WAGES SETTINGS',
    wagesmodule5: 'View profile generated salaries of employees',
    wagesmodule6:
      'Generate monthly payroll lists in employee profiles and allow employees to view their payroll calculations',
    wagesmodule7: 'WAGES SETTINGS',
    wagesmodule8:
      'The calculation and generation of the payroll is done in just three steps',
    wagesmodule9:
      'You need to specify the year and month for which you want to generate and all calculations are done automatically',
    wagesmodule10: 'WAGES',
    wagesmodule11: 'Add employees on the payroll',
    wagesmodule12:
      'Adding or removing from the payroll is very easy and simple',

    onboardmodule: 'Onboard Module',
    trainingmodule: 'Training Module',
    insurancemodule: 'Insurance Module',
    performancemodule: 'Performance Module',
    underconstruction: '>>> Under construction - 35% completed',

    createaccountasjobseeker: 'Create account as Jobseeker',
    fillyourresume: 'Fill your resume',
    vacancyapply: 'Vacancy apply',
    acceptinvitationforinterview: 'Accept invitation for interviews',

    features: 'Features'
  },
  auth_page: {
    jobseeker: 'JOB SEEKER',
    company: 'COMPANY'
  },
  footer: {
    footerdescription:
      'HR bee Management is a cloud-based Human Resources Management software that enables companies to manage their employees and helps job seekers find their dream job. Both can search, connect, and contract seamlessly.',

    product: 'Product',
    jobseeker: 'Job seeker',
    pricing: 'Pricing',
    knowledgebase: 'Knowledge base',
    downloadapp: 'Download App',
    partnerprogram: 'Partner program',
    api: 'API',

    company: 'Company',
    aboutus: 'About us',
    clients: 'Clients',
    partners: 'Partners',
    whereweare: 'Where we are?',
    contactus: 'Contact us',
    support: 'Support',

    allrightreserved: 'All rights © 2020 HR bee Management',
    privacypolicy: 'Privacy & Policy',
    termsconditions: 'Terms & Conditions'
  },
  header_page: {
    editimage: 'Edit image',
    insertimage: 'Add image',
    namesurname: 'Name & Surname',
    title: 'Title',
    birthday: 'Birthday',
    country: 'Country',
    city: 'City',
    nationalID: 'National ID',
    profileID: 'Profile ID',
    shortbio: 'Short biography',
    socialmedia: 'Social media:',

    add: 'Add',
    edit: 'Edit',
    addnow: 'Add now'
  },
  notifications_page: {
    no_notifications: "You don't have new notifications",
    all_notifications: 'All notifications',
    mark_all_as_read: 'Mark all as read'
  },
  navigationlinks: {
    training: 'HR Academy',
    downloadcv: 'Download CV',
    product: 'Product',
    pricing: 'Pricing',
    aboutus: 'About us',
    demo: 'Demo',
    login: 'Log in',
    logout: 'Log out',
    editcv: 'Edit CV Profile',
    dashboard: 'Dashboard',
    language: 'Language',
    newfeeds: 'News Feed',
    vacations: 'Vacations',
    salaries: 'Salaries',
    schedules: 'Work Schedule',
    events: 'Events',
    organogram: 'Company Organogram',
    dresscode: 'Dress Code',
    regulation: 'Regulation',
    vacationrequests: 'Vacation Requests',

    findjobs: 'Find Jobs',
    profileCV: 'Your Profile CV',
    appliedpositions: 'Applied Positions',
    ratingsbyinterviews: 'Ratings by Interviews',

    notifications: 'Notifications',
    nnotifications: 'Notifications',

    savedjobs: 'Jobs Saved',

    registerascompany: 'Register as Company',
    registerasjobseeker: 'Register as Job Seeker',
    forgetpw: 'Forget Password',
    details: 'Details',

    settingaccount: 'Settings Account'
  },

  alerts: {
    are_you_sure: 'Are you sure?',
    are_you_sure_delete: 'Are you sure you want to delete?',
    confirm: 'Confirm',
    successful_login: 'Logged In successfully',
    invalid_credentials: 'The user credentials were incorrect.',
    successful_logout: 'Logged out successfuly',
    successful_register: 'Registered successfully. Please login now.',
    successful_account_activation:
      'Your account has been activated successfully. Please login.',
    successful_account_reset_email:
      'If you have an account with us, shortly you will receive an email.',
    successful_data_loaded: 'Data has been loaded.',
    successful_data_updated: 'Data has been updated.',
    successful_data_deleted: 'Data has been deleted.',
    successful_data_saved: 'Data have been saved.',
    only_images: 'Please choose an image file',
    image_too_big: 'Your file is too big! Please select an image under 2MB',
    candidate_rating_completed: 'Candidate has been rated.',
    package_activation_request_has_been_sent:
      'Module activation request has been sent successfully.',
    successfully_applied_to_job: 'Your application was completed successfully!',
    successfuly_password_changed: 'Password has been changed successfully.',
    successfuly_employee_added_salary_list:
      'Employee has been added to salary list successfully.',
    monthly_salary_generated_succesffuly:
      'Monthly salaries have been generated successfully.',
    monthly_salary_generated_succesffuly_for_user:
      'Monthly salary have been generated successfully for this employee.',
    work_schedule_has_been_updated: 'Work schedule has been updated.',
    payment_billing_cycle_update: 'Payment billing cycle has been updated',
    module_has_been_removed: 'Module has been removed from company account.',
    module_price_has_been_updated:
      'Module details has been updated for the current company.',
    company_module_invoice_deleted_sucessfully: 'Invoice deleted successfully',
    successfull_message_sent:
      'Thank you. Your message has been sent successfully. We will contact you asap.',
    reset_password_sent:
      'If you have an account with us, you will shortly receive an email to reset your password.',
    reset_password_completed:
      'Your password has been reset. Please continue to login.',
    accepted_interview: 'Interview accepted successfully.',
    rejected_interview: 'Interview rejected successfully',
    language_added: 'New language has been saved.',
    language_delete: 'Language deleted successfully.',
    driving_licence_add: 'Driving licence added successfully',
    driving_licence_delete: 'Driving licence deleted successfully',
    same_driving_licence_error:
      'You alredy have this driving licence in your CV',
    computerskill_added: 'New computer skill has been added successfully',
    education_added: 'Your education has been added successfully',
    education_delete: 'Education deleted successfully',
    education_updated: 'Education updated successfully',
    experience_added: 'Your experience has been added successfully',
    experience_updated: 'Experience updated successfully',
    experience_delete: 'Experience deleted successfully',
    training_added: 'Your training/course has been added successfully',
    training_updated: 'Training/course updated successfully',
    training_delete: 'Training/course deleted successfully',
    update_jobseeker: 'Your profile has been updated successfully',
    image_upload: 'Your image has been uploaded successfully',
    noimage: 'No image selected',
    saved_job: 'You saved this job as favorite',
    unsave_job: 'You unsaved this job from favorites',
    computerskill_delete: 'Computer skill deleted successfully',
    otherskill_added: 'New skill has been added successfully',
    otherskill_delete: 'Skill deleted successfully',
    email_already_taken: 'Sorry, this email is already taken.',
    same_skill_error: 'You alredy have this skill in your CV',
    same_language_error: 'You alredy have this language in your CV',
    name_should_only_container_letters: 'Name should only container letter.',
    reset_password_token_expired:
      "You've clicked on Reset Password button in your email before. Please try resetting your password again.",
    acceptedinterview: 'Interview accepted successfully',
    rejectinterview: 'Interview rejected successfully',
    smthwrong: 'Something went wrong, please try again',
    msgsuccess: 'Your message has been sent',
    sum_of_company_and_employee_with_total_insurance:
      'Sum of `Payment from company` and `Payment from employee` should be the same as `Total insurance`',
    total_insurance_more_than_0: 'Total insurance should be more than 0'
  },

  inputs: {
    latitude: 'Latitude',
    longitude: 'Longitude',
    radius_km: 'Radius km',
    title: 'Title',
    serial_number: 'Serial Number',
    description: 'Description',
    allow_emails_when_generating_wages:
      'Employees will be notified or get an email when company generate wages',
    select: 'Select',
    comment: 'Add Comment',
    rate_percentage: 'Rate in %',
    contact_number: 'Contact Number',
    contact_person: 'Contact Person',
    how_do_you_hear_for_us: 'How do you hear for us?',
    country: 'Country',
    probation: 'Probation',
    internship: 'Internship?',
    maritalstatus: 'Marital status',
    email: 'E-mail',
    password: 'Password',
    confirm_password: 'Confirm password',
    current_password: 'Current password',
    age: 'Age',
    first_name: 'First name',
    last_name: 'Last name',
    national_id: 'National ID',
    business_name: 'Business name',
    dateOfBirth_desc: 'Birthdate',
    birthday: 'Birthday',
    phone_number: 'Phone number',
    select_category: 'Select category',
    profession: 'Select profession',
    business_number: 'Business number',
    business_fiscal_number: 'Business no',
    numberofEmployee: 'Number of employee',
    select_country: 'Country',
    select_city: 'City',
    probation_months: 'Probation period - in months',
    health_insurance_monthly_cost: 'Health insurance cost - monthly',
    job_title: 'Title',
    job_title_desc: 'Javascript developer',
    company_name: 'Company name',
    company_name_desc: 'Google',
    current_country: 'Current country',
    training_title: 'Training title',
    started_date: 'Start date',
    join_date: 'Join date',
    status: 'Status',
    statusjob: 'Status of job: ',
    salaryineuro: 'Salary in €',
    jobdsc: 'Vacancy description',
    join_date_desc: 'Date when vacancy start',
    leave_date: 'Leave date',
    finish_date: 'Finish date',
    leave_date_desc: 'Date when vacancy end',
    still_work: 'I still work here',
    still_taking: "I'm still in this training/course",
    still_in_education: 'I have not graduated yet.',
    job_description: 'Job description',
    activities_description: 'Activities',
    select_skill: 'Select a skill',
    select_driving_licence: 'Select a driving licence',
    select_language: 'Select a language',
    edit_image: 'Edit image',
    edit_profile_image: 'Edit profile image',
    short_biography: 'Short biography',
    school_name: 'School name',
    school_name_desc: 'School, university, college name.',
    field_of_study: 'Field of study',
    field_of_study_desc: 'Nursing, Economic...',
    degree: 'Degree',
    degree_desc:
      'Ex: High School Diploma, Associate’s Degree, Bachelor’s Degree, Master’s Degree',
    date_of_birth: 'Date of birth',
    social_links: 'Social links',
    responsible_name_surname: 'Company responsible person',
    new_password: 'Enter new password',
    confirm_new_password: 'Confirm new password',
    nationality: 'Nationality',
    address: 'Address',
    salaryType: 'Salary type',
    job_tags: 'Tags',
    employmentType: 'Employment type',
    department: 'Department',
    sharewithdepartments:
      'Share with departments (leave empty to share with all)',
    position: 'Position',
    start_date: 'Start date',
    start_date_desc: 'Date when contract ends or ended.',
    end_date: 'End date',
    end_date_desc: 'Date when left from this position.',
    conditions: 'Conditions',
    document_type: 'Document type',
    document_title: 'Document title',
    document_description: 'Document description',
    document_expire_date: 'Document expiry date',
    expiry_notification_days: 'Expiry notification days',
    public_holiday_date: 'Please add a unique public holiday',
    fiscal_number: 'Fiscal number',
    fullname: 'Full name',
    message: 'Message',
    message_desc: 'Please type your message.',
    newpassword_confirm: 'Please confirm the new password.',
    gender: 'Gender',
    female: 'Female',
    male: 'Male',
    company_ceo: 'Company CEO',
    head_of_hr: 'Head of HR',
    certificate: 'Business certificate',
    select_member: 'Select member',
    relation: 'Relation',
    total_insurance: 'Insurance total',
    company_insurance: 'Payment from company',
    employee_insurance: 'Payment from employee',
    locale: 'Select a language',
    qualification: 'Qualification',
    orientation: 'Orientation',
    notes: 'notes'
  },

  inputError: {
    targets_required: 'Target fields are required',
    required_terms_conditions: 'Please accept terms before proceeding.',
    account_type_required: 'Please select an account type.',
    required: 'This field is required.',
    national_id_required:
      'National ID has wrong format. Please check and type again.',
    check_email: 'Please check if email exists or typed correctly. ',
    password: 'This fields is required and needs to be at least 6 chars.',
    old_password:
      'Please type old password. At least 6 characters are required.',
    new_password:
      'Please type new password. At least 6 characters are required.',
    confirm_password: 'Confirm password should be the same as password.',
    confirm_new_password:
      'Confirm new password should be the same as new password.',
    terms: 'Please accept terms and conditions.',
    confirm_dialog_delete: 'Are you sure you want to delete this?',
    alert_cannot_add_same_skill:
      'You can not add the same skill. Please add another one.',
    invalid_credentials: 'The user credentials were incorrect.',
    max_file_upload_size_exceeded:
      '5MB File size exceeded. Please upload a smaller file',
    upload_file_first: 'Please upload a file first',
    no_file_added: 'No file added',
    old_password_invalid:
      'Old password is invalid. Please check before trying again.',
    public_holiday_must_be_unique:
      'Please enter another date, public holiday dates should be unique.',
    already_generated_salary_in_this_month:
      'You have already generated salary for this month.',
    already_generated_salary_in_this_month_for_this_user:
      'This employee  has already a generated salary for the month selected.',
    message_required: 'Please type your message',
    fullname_required: 'Please type your full name',
    phone_number_required: 'Please type your phone number',
    email_address_unique_required:
      'Employee email address should be unique. Please add another email address.',
    email_already_taken: 'Sorry, this email is already taken.',
    fill_all_required_fields: 'Please fill all required fields',
    payroll_not_supported_nmk:
      'Payroll is not supported for North Macedonia companies.',
    reset_password_token_expired:
      "You've clicked on Reset Password button in your email before. Please try resetting your password again",
    vacation_dates_already_placed:
      "You've already a vacation placed on this dates you requested. Please change dates.",
    oneIsRequired: 'At least one option is required'
  },

  btn: {
    complete: 'Complete',
    update: 'Update',
    connect: 'Connect',
    disconnect: 'Disconnect',
    delete: 'Delete',
    edit: 'Edit',
    generatewarningletter: 'Generate warning letter',
    printbtn: 'Print',
    generatecontract: 'Generate contract',
    filtejobsbtn: 'Filter Jobs',
    cancelbtn: 'Cancel',
    addbtn: 'Add',
    viewbtn: 'View',
    updatebtn: 'Update',
    savebtn: 'Save',
    detailsbtn: 'Details',
    backbtn: 'Back',
    applynowbtn: 'Apply now',
    applybtn: 'Apply',
    rejectbtn: 'Reject',
    acceptbtn: 'Accept',
    settingaccountbtn: 'Account settings',
    logoutbtn: 'Log out',
    changepwbtn: 'Change password',
    unsave: 'Unsave',
    savedjobsbtn: 'Jobs Saved',
    save: 'Save'
  },

  find_jobs_page: {
    position: 'Position',
    at: 'at',
    deadline: 'Deadline',
    category: 'Category',
    country: 'Country',
    city: 'City',
    alredyapplied: 'Already applied',
    motivationletter: 'Motivation Letter',
    recommendationletter: 'Recommendation Letter',
    refferences: 'Refferences',
    motivationletterinput: 'Please type your motivation letter here',
    recommendationletterinput: 'Please type your recommendation letter here',
    refferencesletterinput: 'Please type your refferences here',
    searchplaceholder: 'Write title of job and hit enter',
    sorrynojobs: 'Sorry there are no jobs!',
    sorrynofavoritejobs: 'You dont have any favorite job!'
  },

  find_jobs_page_filter: {
    filterjobstxt: 'Filter Jobs',
    filterjobstxt2: 'Preparing your list of jobs throw those filter',
    filterbycountry: 'Filter by country',
    filterbycity: 'Filter by city',
    filterbycategory: 'Filter by category',
    filterbysavedjobs: 'Filter by jobs saved',
    selectcountry: 'Select country',
    selectcity: 'Select city',
    selectcategory: 'Select category',
    applyfilterbtn: 'Apply filter',
    filterbysalarytype: 'Filter by salary type',
    selectsalarytype: 'Select salary type',
    filterbyemptype: 'Filter by employment type',
    selectemptype: 'Select employment type',
    savedjobs: 'Jobs Saved',

    searchbytitle: 'Search by title'
  },

  applied_positions_jobseeker_page: {
    position: 'Position',
    category: 'Category',
    country: 'Country',
    city: 'City',
    applicationstatus: 'Application status',
    new_application: 'New application',
    rejected_candidate: 'Application rejected',
    blacklist_candidate: 'Application rejected',
    accepted_interview: 'Accepted interview',
    invited_to_interview: 'Invited to interview',
    rejected_interview: 'Rejected interview',
    potential_candidate: 'Potential candidate',
    hired_candidate: 'Hired candidate',
    nojobapplicationtxt: 'Sorry you dont have any job application!',
    dscnewapplication: 'New application',
    dsctypeinterview: 'Type of interview',
    dscdescriptioninterview: 'Description',
    dscdateandtimeinterview: 'Date and time',
    dscdate: 'Date',
    dsctime: 'Time',
    dscrejected: 'The application was rejected.',
    dscrejectedinterview: 'Interview was rejected by you or company.',
    dscpotentialcandidate: 'You have been added the potential candidate list.',
    dschiredcandidate:
      'Congratulation. This company has hired you for this position. They will get in contact with you shortly.'
  },

  jobseeker_ratings_page: {
    position: 'Position',
    category: 'Category',
    country: 'Country',
    city: 'City',
    backbtn: 'Back',
    detailsbtn: 'Details',
    nojobapplicationnoratingstxt:
      'Sorry you dont have ratings or job applications!',
    averagerate: 'Average rate',
    none: 'None',
    rates: 'Rates',
    rateEducation: 'Education',
    rateExperience: 'Experience',
    rateLanguage: 'Foreign Language',
    rateGeneralKnowledge: 'General Knowledge',
    rateJudgement: 'Judgement Capability',
    rateKnowledgePosition: 'Knowledge about position',
    rateLogical: 'Logical',
    rateITSkills: 'IT skills',
    rateOtherSkills: 'Other skills'
  },

  setting_account_page: {
    settingaccounttxt: 'Setting Account',
    myaccounttxt: 'My account',
    notificationtxt: 'Notification',
    privacytxt: 'Privacy',
    accountinformationtxt: 'Account information',
    mainaccountinfotxt: 'Main account information data',
    changepwtxt: 'Change password',
    changepwdsctxt:
      'If you require to change your account password you can do it here'
  },

  language_proficiency: {
    reading: 'Reading',
    understanding: 'Understanding',
    speaking: 'Speaking',
    writing: 'Writing',
    ELEMENTARY: 'Elementary',
    LIMITED_WORKING: 'Limited working',
    PROFESSIONAL_WORKING: 'Professional working',
    FULL_PROFESSIONAL: 'Full professional',
    NATIVE: 'Native',
    proficiency: 'Proficiency',
    Beginner: 'Beginner',
    Advanced: 'Advanced',
    Average: 'Average',
    Excellent: 'Excellent',
    Professional: 'Professional'
  },

  your_profile_cv: {
    no_experience: 'No experience added',
    show_file: 'Show file',
    no_file: 'No file included',
    no_logo: 'No logo included',
    present: 'Present',
    actions: 'edit | delete',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    add_experience: 'Add Experience',
    add_experience_1: 'Add your working experience',
    position: 'Position',
    check_uncheck: 'check | uncheck',
    add_document: 'Add Document',
    image_company: 'Add company logo',
    alredy_have_image: 'You alredy have a logo of company',
    edit_experience: 'Edit Experience',
    alredy_have_document:
      'You already have a document. Insert new one if you want to change it',

    no_education: 'No education added',
    school_name: 'School name',
    field_study: 'Field of study',
    from_to: 'from - up to',
    level_education: 'Level of education',
    city: 'City',
    country: 'Country',
    file: 'File',
    add_education: 'Add Education',
    add_education_1: 'Add education that you followed',
    other_degree: 'Other Degree',
    other_field_study: 'Other field of study',
    edit_education: 'Edit Education',

    no_training: 'No training added',
    institution: 'Institution',
    training_course: 'Training | Course',
    add_training: 'Add Training | Course',
    add_training_1: 'Add your trainings that you followed',
    edit_training: 'Edit Training | Course',

    no_language: 'No language added',
    language: 'Language',
    add_language: 'Add Language',
    add_language_1: 'Select language that you know',

    no_c_skill: 'No computer skill added',
    skill: 'Skill',
    level: 'Level',
    add_c_skill: 'Add computer skills',
    add_c_skill_1: 'Add skills that you know',
    select_skill: 'Select skill',
    select_level: 'Select level',

    no_o_skill: 'No other skill added',
    add_o_skill: 'Add other skills',
    add_o_skill_1: 'Add skill that you know',

    no_driving: 'No driving licence added',
    add_driving: 'Add driving licence',
    add_driving_1: 'Add driving licence that you have',
    category_license: 'Category License'
  },

  notifications: {
    requested_vacation: 'requested vacation.',
    job_new_application: 'applied for',
    admin_approved_package_request:
      'admin approved your package activation request',
    invited_interview: 'invited you to interview for',
    rejected_interview: 'rejected your application for',
    rated_profile: 'rated your CV on'
  },

  page_titles: {
    company_jobs: 'Company jobs',
    add_new_job: 'Add new job',
    candidate_interviews: 'Candidate interviews',
    rated_candidates: 'Rated candidates',
    company_employees: 'Company employees',
    main_profile_data: 'Main profile data',
    employees_salary_list: 'Employees salary list',
    assign_employee: 'Assign employee',
    generated_salaries: 'Generated salaries'
  },

  navigation: {
    search_jobs: 'Search jobs',
    resume: 'Resume',
    download_resume: 'Download resume',
    applied_positions: 'Applied positions',
    ratings: 'Ratings',
    account_settings: 'Account settings',
    no_notification: "You don't have any new notification.",
    all_notifications: 'All notifications',
    mark_all_as_read: 'Mark all as read',
    logout: 'Log out',
    feeds: 'Feeds',
    recruitment: 'Recruitment',
    jobs: 'Jobs',
    interviews: 'Interviews',
    blacklist: 'Blacklist',
    employees: 'Employees',
    all_employees: 'All employees',
    birthdays: 'Birthdays',
    performance_settings: 'Performance settings',
    work_schedule: 'Work schedule',
    vacations: 'Vacations',
    vacation_requests: 'Vacation requests',
    public_holiday_settings: 'Public holiday settings',
    general_vacation_settings: 'General vacation settings',
    finances: 'Finances',
    employee_salaries: 'Employee salaries',
    generate_salaries: 'Generate salaries',
    payment_settings: 'Payment settings',
    organogram: 'Organogram',
    regulations: 'Regulations',
    dress_code: 'Dress code',
    profile: 'Profile',
    work_details: 'Work details',
    performance: 'Performance',
    documents: 'Documents',
    salary: 'Salary'
  },

  button: {
    create_cv: 'Create your CV',
    are_you_a_company: 'Are you a company?',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    export: 'Export',
    update: 'Update',
    chooseImage: 'Choose image',
    removeImage: 'Remove image',
    rate: 'Rate',
    reject: 'Reject',
    book_time_off: 'Book time off',
    send_message: 'Send message',
    save_job_details: 'Save job details',
    back: 'Back',
    next: 'Next'
  },

  authentication_page: {
    signup: 'Sign Up',
    createaccount: 'Create account',
    company: 'Company',
    jobseeker: 'Jobseeker',
    nav_button_create_account: 'Create an account',
    next_step_button: 'Next step',
    login_button: 'Log In',
    reset_button: 'Reset password',
    create_account_button: 'Create account',
    continue: 'Vazhdo',
    auth_main_title: 'Create an account wit HRbee.',
    auth_main_title_desc: 'Select user type that represents you',
    box_jobseeker_title: 'JOB SEEKER',
    box_jobseeker_title_desc:
      'You are a individual who is looking to hired by an employer.',
    box_jobseeker_title_checbox: "I'm a job seeker",
    box_employer_title: 'EMPLOYER',
    box_employer_title_desc:
      'You are a legal entity that is looking to hire job seekers.',
    box_employer_title_checbox: "I'm an Employer",
    account_page_title: 'Account information',
    business_account_page_title: 'Information about your business',
    account_page_title_desc: 'Please provide your account information data.',
    jobseeker_account_login_button: 'Log in to account',
    terms_conditions_1: "I've read and accept",
    terms_conditions_2: 'terms and conditions',
    auth_bottom_links_forgot_1: 'Forgot',
    auth_bottom_links_forgot_2: 'password?',
    auth_bottom_links_login_1: 'Don’t have an account? Create your account',
    auth_bottom_links_login_2: 'here!',
    auth_bottom_links_login_3: 'Alredy have an account and I want to',
    auth_bottom_links_login_4: 'login!'
  },

  businessCategories: {
    administrate: 'Accountant',
    agronomi: 'Agronomy',
    arkitekture: 'Architecture',
    arsim_edukim: 'Education',
    banka_financa: 'Banking & Finance',
    call_center: 'Call center',
    hoteleri_turizem: 'Hotel & Tourism',
    inxhinieri: 'Engineering',
    juridik: 'Law',
    kontabilitet: 'Accounting',
    logjistike: 'Logistics',
    marketing_reklamim: 'Marketing & Advertising',
    media: 'Media',
    menaxhment: 'Management',
    ndertimtari: 'Construction',
    prodhimtari: 'Productivity',
    sherbime_shendetsore: 'Health services',
    sherbime_klienteve: 'Customer services',
    shitje: 'Sales',
    sigurime: 'Insurance',
    sport: 'Sport',
    teknologji_informative: 'Information Technology - IT',
    telekomunikacion: 'Telecommunication',
    tjera: 'Other',
    trajnim_konsulence: 'Training & Counseling'
  },

  jobseeker_profile_page: {
    tab_experience: 'Experience',
    tab_education: 'Education',
    tab_training_courses: 'Training/Courses',
    tab_languages: 'Languages',
    tab_computer_skills: 'Computer skills',
    tab_other_skills: 'Other skills',
    tab_driving_skills: 'Driving licence'
  },

  package_modules: {
    pricingofpackages: 'Pricing of packages',
    package: 'Package',
    free: 'Free',
    basic: 'Basic',
    standart: 'Standart',
    premium: 'Premium',
    loadingbtn: 'Loading',

    feeds: 'News Feeds Module',
    recruitment: 'Recuritment Module',
    management: 'Management Module',
    workSchedule: 'Work Schedule Module',
    vacation: 'Vacation Module',
    wages: 'Wages Module',
    training: 'Training Module',
    performance: 'Performance Module',
    timeLineProject: 'Time Line Project Module',
    insurance: 'Insurance Module',
    buttonGetStarted: 'Get Started',

    nopackages: 'No active company packages'
  },

  EducationFieldStudies: {
    Primary: 'Primary',
    music: 'Music',
    dance: 'Dance',
    theatre: 'Theatre',
    film_studies: 'Film Studies',
    fine_arts: 'Fine Arts',
    applied_arts: 'Applied Arts',
    animation: 'Animation',
    calligraphy: 'Calligraphy',
    decorative_arts: 'Decorative Arts',
    mixed_media: 'Mixed Media',
    printmaking: 'Printmaking',
    studio_art: 'Studio Art',
    architecture: 'Architecture',
    design: 'Design',
    history: 'History',
    languages_and_literature: 'Languages And Literature',
    linguistics: 'Linguistics',
    comparative_literature: 'Comparative Literature',
    creative_writing: 'Creative Writing',
    english_literature: 'English Literature',
    history_of_literature: 'History Of Literature',
    literary_theory: 'Literary Theory',
    poetry: 'Poetry',
    world_literature: 'World Literature',
    philosophy: 'Philosophy',
    aesthetics: 'Aesthetics',
    epistemology: 'Epistemology',
    ethics: 'Ethics',
    history_of_philosophy: 'History Of Philosophy',
    logic: 'Logic',
    meta_philosophy: 'Meta Philosophy',
    metaphysics: 'Metaphysics',
    philosophical_movement: 'Philosophical Movement',
    political_philosophy: 'Political Philosophy',
    theology_: 'Theology',
    biblical_studies: 'Biblical Studies',
    religious_studies: 'Religious Studies',
    aramaic: 'Aramaic',
    buddhist_devotion: 'Buddhist Devotion',
    christian_theology: 'Christian Theology',
    hindu_theology: 'Hindu Theology',
    jewish_theology: 'Jewish Theology',
    muslim_theology: 'Muslim Theology',
    social_sciences: 'Social Sciences',
    biological_anthropology: 'Biological Anthropology',
    linguistic_anthropology: 'Linguistic Anthropology',
    cultural_anthropology: 'Cultural Anthropology',
    social_anthropology: 'Social Anthropology',
    archaeology: 'Archaeology',
    agricultural_economics: 'Agricultural Economics',
    anarchist_economics: 'Anarchist Economics',
    applied_economics: 'Applied Economics',
    behavioural_economics: 'Behavioural Economics',
    bioeconomics: 'Bioeconomics',
    complexity_economics: 'Complexity Economics',
    computational_economics: 'Computational Economics',
    consumer_economics: 'Consumer Economics',
    development_economics: 'Development Economics',
    ecological_economics: 'Ecological Economics',
    econometrics: 'Econometrics',
    economic_geography: 'Economic Geography',
    economic_history: 'Economic History',
    economic_sociology: 'Economic Sociology',
    economic_systems: 'Economic Systems',
    energy_economics: 'Energy Economics',
    entrepreneurial_economics: 'Entrepreneurial Economics',
    environmental_economics: 'Environmental Economics',
    evolutionary_economics: 'Evolutionary Economics',
    experimental_economics: 'Experimental Economics',
    feminist_economics: 'Feminist Economics',
    financial_econometrics: 'Financial Econometrics',
    financial_economics: 'Financial Economics',
    green_economics: 'Green Economics',
    economic_growth: 'Economic Growth',
    human_development_theory: 'Human Development Theory',
    industrial_organization: 'Industrial Organization',
    information_economics: 'Information Economics',
    institutional_economics: 'Institutional Economics',
    international_economics: 'International Economics',
    islamic_economics: 'Islamic Economics',
    labor_economics: 'Labor Economics',
    law_and_economics: 'Law And Economics',
    macroeconomics: 'Macroeconomics',
    managerial_economics: 'Managerial Economics',
    marxian_economics: 'Marxian Economics',
    mathematical_economics: 'Mathematical Economics',
    microeconomics: 'Microeconomics',
    monetary_economics: 'Monetary Economics',
    neuroeconomics: 'Neuroeconomics',
    participatory_economics: 'Participatory Economics',
    political_economy: 'Political Economy',
    public_economics: 'Public Economics',
    public_finance: 'Public Finance',
    real_estate_economics: 'Real Estate Economics',
    resource_economics: 'Resource Economics',
    social_choice_theory: 'Social Choice Theory',
    socialist_economics: 'Socialist Economics',
    socioeconomics: 'Socioeconomics',
    transport_economics: 'Transport Economics',
    welfare_economics: 'Welfare Economics',
    marketing: 'Marketing',
    human_geography: 'Human Geography',
    administrative_law: 'Administrative Law',
    canon_law: 'Canon Law',
    civil_law: 'Civil Law',
    comparative_law: 'Comparative Law',
    competition_law: 'Competition Law',
    constitutional_law: 'Constitutional Law',
    criminal_law: 'Criminal Law',
    'sharia|islamic_law': 'Sharia|Islamic Law',
    jewish_law: 'Jewish Law',
    jurisprudence: 'Jurisprudence',
    legal_management: 'Legal Management',
    procedural_law: 'Procedural Law',
    substantive_law: 'Substantive Law',
    politics_of_canada: 'Politics Of Canada',
    civics: 'Civics',
    comparative_politics: 'Comparative Politics',
    european_studies: 'European Studies',
    geopolitics: 'Geopolitics',
    international_relations: 'International Relations',
    international_organizations: 'International Organizations',
    nationalism_studies: 'Nationalism Studies',
    peace_and_conflict_studies: 'Peace And Conflict Studies',
    policy_studies: 'Policy Studies',
    theories_of_political_behavior: 'Theories Of Political Behavior',
    political_culture: 'Political Culture',
    political_history: 'Political History',
    psephology: 'Psephology',
    abnormal_psychology: 'Abnormal Psychology',
    applied_psychology: 'Applied Psychology',
    asian_psychology: 'Asian Psychology',
    biological_psychology: 'Biological Psychology',
    black_psychology: 'Black Psychology',
    clinical_neuropsychology: 'Clinical Neuropsychology',
    clinical_psychology: 'Clinical Psychology',
    cognitive_psychology: 'Cognitive Psychology',
    community_psychology: 'Community Psychology',
    comparative_psychology: 'Comparative Psychology',
    conservation_psychology: 'Conservation Psychology',
    consumer_psychology: 'Consumer Psychology',
    counseling_psychology: 'Counseling Psychology',
    criminal_psychology: 'Criminal Psychology',
    cultural_psychology: 'Cultural Psychology',
    developmental_psychology: 'Developmental Psychology',
    differential_psychology: 'Differential Psychology',
    ecological_psychology: 'Ecological Psychology',
    educational_psychology: 'Educational Psychology',
    environmental_psychology: 'Environmental Psychology',
    evolutionary_psychology: 'Evolutionary Psychology',
    experimental_psychology: 'Experimental Psychology',
    group_dynamics: 'Group Dynamics',
    journal_of_family_psychology: 'Journal Of Family Psychology',
    feminine_psychology: 'Feminine Psychology',
    forensic_developmental_psychology: 'Forensic Developmental Psychology',
    forensic_psychology: 'Forensic Psychology',
    health_psychology: 'Health Psychology',
    humanistic_psychology: 'Humanistic Psychology',
    indigenous_psychology: 'Indigenous Psychology',
    legal_psychology: 'Legal Psychology',
    masculine_psychology: 'Masculine Psychology',
    mathematical_psychology: 'Mathematical Psychology',
    media_psychology: 'Media Psychology',
    medical_psychology: 'Medical Psychology',
    military_psychology: 'Military Psychology',
    descriptive_ethics: 'Descriptive Ethics',
    music_psychology: 'Music Psychology',
    neuropsychology: 'Neuropsychology',
    occupational_health_psychology: 'Occupational Health Psychology',
    occupational_psychology: 'Occupational Psychology',
    industrial_and_organizational_psychology:
      'Industrial And Organizational Psychology',
    parapsychology: 'Parapsychology',
    pediatric_psychology: 'Pediatric Psychology',
    pedology: 'Pedology',
    personality_psychology: 'Personality Psychology',
    phenomenology: 'Phenomenology',
    political_psychology: 'Political Psychology',
    positive_psychology: 'Positive Psychology',
    psychoanalysis: 'Psychoanalysis',
    psychobiology: 'Psychobiology',
    psychology_of_religion: 'Psychology Of Religion',
    psychometrics: 'Psychometrics',
    psychopathology: 'Psychopathology',
    psychophysics: 'Psychophysics',
    quantitative_psychology: 'Quantitative Psychology',
    rehabilitation_psychology_journal: 'Rehabilitation Psychology Journal',
    school_psychology: 'School Psychology',
    social_psychology: 'Social Psychology',
    sport_psychology: 'Sport Psychology',
    traffic_psychology: 'Traffic Psychology',
    transpersonal_psychology: 'Transpersonal Psychology',
    analytical_sociology: 'Analytical Sociology',
    applied_sociology: 'Applied Sociology',
    collective_behavior: 'Collective Behavior',
    chinese_sociology: 'Chinese Sociology',
    community_informatics: 'Community Informatics',
    comparative_sociology: 'Comparative Sociology',
    conflict_theories: 'Conflict Theories',
    criminology: 'Criminology',
    critical_management_studies: 'Critical Management Studies',
    critical_sociology: 'Critical Sociology',
    cultural_sociology: 'Cultural Sociology',
    cultural_studies: 'Cultural Studies',
    demography: 'Demography',
    digital_sociology: 'Digital Sociology',
    dramaturgical_sociology: 'Dramaturgical Sociology',
    educational_sociology: 'Educational Sociology',
    empirical_sociology: 'Empirical Sociology',
    environmental_sociology: 'Environmental Sociology',
    evolutionary_sociology: 'Evolutionary Sociology',
    feminist_sociology: 'Feminist Sociology',
    figurational_sociology: 'Figurational Sociology',
    futures_studies: 'Futures Studies',
    gender_studies: 'Gender Studies',
    historical_sociology: 'Historical Sociology',
    human_ecology: 'Human Ecology',
    humanistic_sociology: 'Humanistic Sociology',
    industrial_sociology: 'Industrial Sociology',
    interactionism: 'Interactionism',
    interpretive_sociology: 'Interpretive Sociology',
    jealousy_sociology: 'Jealousy Sociology',
    macrosociology: 'Macrosociology',
    marxist_sociology: 'Marxist Sociology',
    mathematical_sociology: 'Mathematical Sociology',
    medical_sociology: 'Medical Sociology',
    mesosociology: 'Mesosociology',
    microsociology: 'Microsociology',
    military_sociology: 'Military Sociology',
    natural_resource_sociology: 'Natural Resource Sociology',
    organizational_studies: 'Organizational Studies',
    phenomenological_sociology: 'Phenomenological Sociology',
    policy_sociology: 'Policy Sociology',
    psychoanalytic_sociology: 'Psychoanalytic Sociology',
    science_studies: 'Science Studies',
    sexology: 'Sexology',
    social_capital: 'Social Capital',
    social_change: 'Social Change',
    social_conflict_theory: 'Social Conflict Theory',
    social_control: 'Social Control',
    social_economy: 'Social Economy',
    social_philosophy: 'Social Philosophy',
    social_policy: 'Social Policy',
    social_research: 'Social Research',
    social_stratification: 'Social Stratification',
    social_theory: 'Social Theory',
    social_transformation: 'Social Transformation',
    sociobiology: 'Sociobiology',
    sociocybernetics: 'Sociocybernetics',
    sociolinguistics: 'Sociolinguistics',
    sociological_theory: 'Sociological Theory',
    gerontology: 'Gerontology',
    rural_sociology: 'Rural Sociology',
    sociology_of_art: 'Sociology Of Art',
    societal_and_cultural_aspects_of_autism:
      'Societal And Cultural Aspects Of Autism',
    sociology_of_the_family: 'Sociology Of The Family',
    social_conflict: 'Social Conflict',
    sociology_of_culture: 'Sociology Of Culture',
    sociology_of_the_internet: 'Sociology Of The Internet',
    development_theory: 'Development Theory',
    deviance_sociology: 'Deviance Sociology',
    sociology_of_disaster: 'Sociology Of Disaster',
    sociology_of_education: 'Sociology Of Education',
    sociology_of_emotions: 'Sociology Of Emotions',
    social_studies_of_finance: 'Social Studies Of Finance',
    sociology_of_food: 'Sociology Of Food',
    sociology_of_gender: 'Sociology Of Gender',
    theory_of_generation: 'Theory Of Generation',
    world_systems_theory: 'World Systems Theory',
    political_sociology: 'Political Sociology',
    sociology_of_health_and_illness: 'Sociology Of Health And Illness',
    sociology_of_human_consciousness: 'Sociology Of Human Consciousness',
    sociology_of_immigration: 'Sociology Of Immigration',
    sociology_of_knowledge: 'Sociology Of Knowledge',
    sociology_of_language: 'Sociology Of Language',
    sociology_of_law: 'Sociology Of Law',
    sociology_of_leisure: 'Sociology Of Leisure',
    sociology_of_literature: 'Sociology Of Literature',
    sociomusicology: 'Sociomusicology',
    natural_resource_management: 'Natural Resource Management',
    organizational_behavior: 'Organizational Behavior',
    sociology_of_peace: 'Sociology Of Peace',
    sociology_of_punishment: 'Sociology Of Punishment',
    sociology_of_race_and_ethnic_relations:
      'Sociology Of Race And Ethnic Relations',
    sociology_of_religion: 'Sociology Of Religion',
    'risk|sociology_of_risk': 'Risk|Sociology Of Risk',
    sociology_of_scientific_knowledge: 'Sociology Of Scientific Knowledge',
    social_movement: 'Social Movement',
    sociology_of_space: 'Sociology Of Space',
    sociology_of_sport: 'Sociology Of Sport',
    'science,_technology_and_society': 'Science, Technology And Society',
    sociology_of_terrorism: 'Sociology Of Terrorism',
    sociology_of_the_body: 'Sociology Of The Body',
    sociology_of_the_history_of_science: 'Sociology Of The History Of Science',
    structural_sociology: 'Structural Sociology',
    theoretical_sociology: 'Theoretical Sociology',
    urban_sociology: 'Urban Sociology',
    victimology: 'Victimology',
    visual_sociology: 'Visual Sociology',
    aerobiology: 'Aerobiology',
    anatomy: 'Anatomy',
    biochemistry: 'Biochemistry',
    bioinformatics: 'Bioinformatics',
    biophysics: 'Biophysics',
    biotechnology: 'Biotechnology',
    botany: 'Botany',
    cell_biology: 'Cell Biology',
    chronobiology: 'Chronobiology',
    computational_biology: 'Computational Biology',
    cryobiology: 'Cryobiology',
    developmental_biology: 'Developmental Biology',
    ecology: 'Ecology',
    endocrinology: 'Endocrinology',
    evolutionary_biology: 'Evolutionary Biology',
    genetics: 'Genetics',
    histology: 'Histology',
    human_biology: 'Human Biology',
    immunology: 'Immunology',
    limnology: 'Limnology',
    linnaean_taxonomy: 'Linnaean Taxonomy',
    marine_biology: 'Marine Biology',
    mathematical_biology: 'Mathematical Biology',
    microbiology: 'Microbiology',
    molecular_biology: 'Molecular Biology',
    mycology: 'Mycology',
    neuroscience: 'Neuroscience',
    nutrition: 'Nutrition',
    paleobiology: 'Paleobiology',
    parasitology: 'Parasitology',
    pathology: 'Pathology',
    physiology: 'Physiology',
    structural_biology: 'Structural Biology',
    systematics: 'Systematics',
    systems_biology: 'Systems Biology',
    virology: 'Virology',
    xenobiology: 'Xenobiology',
    zoology: 'Zoology',
    agrochemistry: 'Agrochemistry',
    analytical_chemistry: 'Analytical Chemistry',
    astrochemistry: 'Astrochemistry',
    atmospheric_chemistry: 'Atmospheric Chemistry',
    chemical_biology: 'Chemical Biology',
    chemical_engineering: 'Chemical Engineering',
    cheminformatics: 'Cheminformatics',
    computational_chemistry: 'Computational Chemistry',
    cosmochemistry: 'Cosmochemistry',
    electrochemistry: 'Electrochemistry',
    environmental_chemistry: 'Environmental Chemistry',
    femtochemistry: 'Femtochemistry',
    flavor: 'Flavor',
    flow_chemistry: 'Flow Chemistry',
    geochemistry: 'Geochemistry',
    green_chemistry: 'Green Chemistry',
    histochemistry: 'Histochemistry',
    hydrogenation: 'Hydrogenation',
    immunochemistry: 'Immunochemistry',
    inorganic_chemistry: 'Inorganic Chemistry',
    marine_chemistry: 'Marine Chemistry',
    mathematical_chemistry: 'Mathematical Chemistry',
    mechanochemistry: 'Mechanochemistry',
    medicinal_chemistry: 'Medicinal Chemistry',
    molecular_mechanics: 'Molecular Mechanics',
    nanotechnology: 'Nanotechnology',
    natural_product_chemistry: 'Natural Product Chemistry',
    neurochemistry: 'Neurochemistry',
    oenology: 'Oenology',
    organic_chemistry: 'Organic Chemistry',
    organometallic_chemistry: 'Organometallic Chemistry',
    petrochemistry: 'Petrochemistry',
    pharmacology: 'Pharmacology',
    photochemistry_: 'Photochemistry',
    physical_chemistry: 'Physical Chemistry',
    physical_organic_chemistry: 'Physical Organic Chemistry',
    phytochemistry: 'Phytochemistry',
    polymer_chemistry: 'Polymer Chemistry',
    quantum_chemistry: 'Quantum Chemistry',
    radiochemistry: 'Radiochemistry',
    solid_state_chemistry: 'Solid State Chemistry',
    sonochemistry: 'Sonochemistry',
    supramolecular_chemistry: 'Supramolecular Chemistry',
    surface_chemistry: 'Surface Chemistry',
    synthetic_chemistry: 'Synthetic Chemistry',
    theoretical_chemistry: 'Theoretical Chemistry',
    thermochemistry: 'Thermochemistry',
    edaphology: 'Edaphology',
    environmental_science: 'Environmental Science',
    gemology: 'Gemology',
    geodesy: 'Geodesy',
    physical_geography: 'Physical Geography',
    geophysics: 'Geophysics',
    paleontology: 'Paleontology',
    astrobiology: 'Astrobiology',
    astronomy: 'Astronomy',
    astrophysics: 'Astrophysics',
    interstellar_medium: 'Interstellar Medium',
    direct_numerical_simulation: 'Direct Numerical Simulation',
    physical_cosmology: 'Physical Cosmology',
    'star|stellar_astrophysics': 'Star|Stellar Astrophysics',
    planetary_science: 'Planetary Science',
    _physics_: 'Physics',
    acoustics: 'Acoustics',
    applied_physics: 'Applied Physics',
    'atomic,_molecular': 'Atomic, Molecular',
    computational_physics: 'Computational Physics',
    condensed_matter_physics: 'Condensed Matter Physics',
    cryogenics: 'Cryogenics',
    electromagnetism: 'Electromagnetism',
    elementary_particle_physics: 'Elementary Particle Physics',
    experimental_physics: 'Experimental Physics',
    fluid_dynamics: 'Fluid Dynamics',
    mathematical_physics: 'Mathematical Physics',
    mechanics: 'Mechanics',
    medical_physics: 'Medical Physics',
    molecular_physics: 'Molecular Physics',
    newtons_laws_of_motion: 'Newtons Laws Of Motion',
    nuclear_physics: 'Nuclear Physics',
    optics: 'Optics',
    plasma_physics: 'Plasma Physics',
    quantum_physics: 'Quantum Physics',
    solid_mechanics: 'Solid Mechanics',
    solid_state_physics: 'Solid State Physics',
    statistical_mechanics: 'Statistical Mechanics',
    theoretical_physics: 'Theoretical Physics',
    thermodynamics: 'Thermodynamics',
    vehicle_dynamics: 'Vehicle Dynamics',
    computer_science: 'Computer Science',
    logic_in_computer_science: 'Logic In Computer Science',
    algorithms: 'Algorithms',
    artificial_intelligence: 'Artificial Intelligence',
    data_structures: 'Data Structures',
    computer_architecture: 'Computer Architecture',
    computer_graphics: 'Computer Graphics',
    computer_networking: 'Computer Networking',
    high_availability: 'High Availability',
    medicine: 'Medicine',
    professions: 'Professions',
    distributed_computing: 'Distributed Computing',
    human_computer_interaction: 'Human Computer Interaction',
    operating_systems: 'Operating Systems',
    parallel_computing: 'Parallel Computing',
    programming_languages: 'Programming Languages',
    quantum_computing: 'Quantum Computing',
    software_engineering: 'Software Engineering',
    theory_of_computation: 'Theory Of Computation',
    very_large_scale_integration: 'Very Large Scale Integration',
    mathematics: 'Mathematics',
    foundations_of_mathematics: 'Foundations Of Mathematics',
    algebra: 'Algebra',
    mathematical_analysis: 'Mathematical Analysis',
    probability_theory: 'Probability Theory',
    topology: 'Topology',
    number_theory: 'Number Theory',
    approximation_theory: 'Approximation Theory',
    combinatorics: 'Combinatorics',
    cryptography: 'Cryptography',
    dynamical_systems: 'Dynamical Systems',
    game_theory: 'Game Theory',
    graph_theory: 'Graph Theory',
    information_theory: 'Information Theory',
    numerical_analysis: 'Numerical Analysis',
    operations_research: 'Operations Research',
    statistics: 'Statistics',
    astrostatistics: 'Astrostatistics',
    biostatistics: 'Biostatistics',
    bioengineering: 'Bioengineering',
    catalysis: 'Catalysis',
    materials_engineering: 'Materials Engineering',
    molecular_engineering: 'Molecular Engineering',
    polymer_engineering: 'Polymer Engineering',
    process_design: 'Process Design',
    process_engineering: 'Process Engineering',
    reaction_engineering: 'Reaction Engineering',
    transport_phenomena: 'Transport Phenomena',
    coastal_engineering: 'Coastal Engineering',
    earthquake_engineering: 'Earthquake Engineering',
    ecological_engineering: 'Ecological Engineering',
    environmental_engineering: 'Environmental Engineering',
    geotechnical_engineering: 'Geotechnical Engineering',
    hydraulic_engineering_: 'Hydraulic Engineering',
    mining_engineering: 'Mining Engineering',
    transportation_engineering: 'Transportation Engineering',
    structural_engineering: 'Structural Engineering',
    structural_mechanics: 'Structural Mechanics',
    surveying: 'Surveying',
    instructional_design: 'Instructional Design',
    human_performance_technology: 'Human Performance Technology',
    knowledge_management: 'Knowledge Management',
    computer_engineering: 'Computer Engineering',
    control_engineering: 'Control Engineering',
    electronic_engineering: 'Electronic Engineering',
    engineering_physics: 'Engineering Physics',
    mechatronics: 'Mechatronics',
    power_engineering: 'Power Engineering',
    robotics: 'Robotics',
    semiconductors: 'Semiconductors',
    telecommunications_engineering: 'Telecommunications Engineering',
    biomaterials: 'Biomaterials',
    ceramic_engineering: 'Ceramic Engineering',
    crystallography: 'Crystallography',
    nanomaterials: 'Nanomaterials',
    photonics: 'Photonics',
    metallurgy: 'Metallurgy',
    polymer_science: 'Polymer Science',
    aerospace_engineering: 'Aerospace Engineering',
    acoustical_engineering: 'Acoustical Engineering',
    automotive_engineering: 'Automotive Engineering',
    biomedical_engineering: 'Biomedical Engineering',
    continuum_mechanics: 'Continuum Mechanics',
    fluid_mechanics: 'Fluid Mechanics',
    heat_transfer: 'Heat Transfer',
    industrial_engineering: 'Industrial Engineering',
    manufacturing_engineering: 'Manufacturing Engineering',
    marine_propulsion: 'Marine Propulsion',
    mass_transfer: 'Mass Transfer',
    nanoengineering: 'Nanoengineering',
    offshore_construction: 'Offshore Construction',
    optical_engineering: 'Optical Engineering',
    vehicle_engineering: 'Vehicle Engineering',
    chaos_theory: 'Chaos Theory',
    complex_system: 'Complex System',
    complex_systems: 'Complex Systems',
    conceptual_systems: 'Conceptual Systems',
    control_theory: 'Control Theory',
    cybernetics: 'Cybernetics',
    network_science: 'Network Science',
    system_dynamics: 'System Dynamics',
    systems_ecology: 'Systems Ecology',
    systems_engineering: 'Systems Engineering',
    systems_psychology: 'Systems Psychology',
    systems_theory: 'Systems Theory',
    systems_theory_in_anthropology: 'Systems Theory In Anthropology',
    medicine_and_health: 'Medicine And Health',
    alternative_medicine: 'Alternative Medicine',
    clinical_laboratory_sciences: 'Clinical Laboratory Sciences',
    clinical_physiology: 'Clinical Physiology',
    dentistry: 'Dentistry',
    dermatology: 'Dermatology',
    emergency_medicine: 'Emergency Medicine',
    geriatrics: 'Geriatrics',
    gynaecology: 'Gynaecology',
    health_informatics: 'Health Informatics',
    hematology: 'Hematology',
    infectious_disease: 'Infectious Disease',
    intensive_care_medicine: 'Intensive Care Medicine',
    internal_medicine: 'Internal Medicine',
    medical_toxicology: 'Medical Toxicology',
    music_therapy: 'Music Therapy',
    nursing: 'Nursing',
    dietetics: 'Dietetics',
    obstetrics: 'Obstetrics',
    occupational_hygiene: 'Occupational Hygiene',
    occupational_therapy: 'Occupational Therapy',
    occupational_toxicology: 'Occupational Toxicology',
    ophthalmology: 'Ophthalmology',
    optometry: 'Optometry',
    otolaryngology: 'Otolaryngology',
    pediatrics: 'Pediatrics',
    pharmaceutical_sciences: 'Pharmaceutical Sciences',
    physical_fitness: 'Physical Fitness',
    physical_therapy: 'Physical Therapy',
    physiotherapy: 'Physiotherapy',
    podiatry: 'Podiatry',
    preventive_healthcare: 'Preventive Healthcare',
    primary_care: 'Primary Care',
    psychiatry: 'Psychiatry',
    psychology: 'Psychology',
    public_health: 'Public Health',
    radiology: 'Radiology',
    recreational_therapy: 'Recreational Therapy',
    physical_medicine_and_rehabilitation:
      'Physical Medicine And Rehabilitation',
    respiratory_therapy: 'Respiratory Therapy',
    sleep_medicine: 'Sleep Medicine',
    speech_language_pathology: 'Speech Language Pathology',
    sports_medicine: 'Sports Medicine',
    surgery: 'Surgery',
    traditional_medicine: 'Traditional Medicine',
    urology: 'Urology',
    veterinary_medicine: 'Veterinary Medicine',
    other: 'Other'
  },

  EducationDegrees: {
    ps: 'Primary School (PS)',
    hs: 'High School (HS)',
    prs: 'Professional School (PRS)',
    st: 'Student (ST)',
    ba: 'Bachelor (BA)',
    ma: 'Master (MA)',
    phd: 'Doctor of Philosophy (PhD)',
    other: 'Other'
  }
}
